/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type OdProtosCommon_Date = {
  __typename?: 'OdProtosCommon_Date';
  day: number;
  month: number;
  year: number;
};

export type OdProtosCommon_Time = {
  __typename?: 'OdProtosCommon_Time';
  hours: number;
  minutes: number;
};

export enum Badge {
  AVAILABLE_SOON = 'AVAILABLE_SOON',
  IN_CONTRACT = 'IN_CONTRACT',
  IS_EXCLUSIVE = 'IS_EXCLUSIVE',
  ON_THE_MARKET = 'ON_THE_MARKET',
  RECENTLY_SOLD = 'RECENTLY_SOLD',
  /** A property that is possibly still for sale but is unactionable at the moment */
  TEMP_UNAVAILABLE = 'TEMP_UNAVAILABLE',
  /** A home that is for sale but cannot be self-toured, must be bought with an agent via MLS */
  TRADITIONAL = 'TRADITIONAL',
  UNKNOWN = 'UNKNOWN'
}

/**
 * A list of task types a customer may be required to complete in order to facilitate
 * their transaction, both OBO and non-OBO
 */
export enum BuyClosingTaskType {
  APPRAISAL = 'APPRAISAL',
  BUY_DIRECT_EARNEST_MONEY = 'BUY_DIRECT_EARNEST_MONEY',
  BUY_DIRECT_FINAL_WALKTHROUGH = 'BUY_DIRECT_FINAL_WALKTHROUGH',
  BUY_DIRECT_INFO_TITLE_ESCROW = 'BUY_DIRECT_INFO_TITLE_ESCROW',
  BUY_DIRECT_REVIEW_DISCLOSURES = 'BUY_DIRECT_REVIEW_DISCLOSURES',
  BUY_DIRECT_SCHEDULE_INSPECTION = 'BUY_DIRECT_SCHEDULE_INSPECTION',
  BUY_DIRECT_SIGN_CONTRACT = 'BUY_DIRECT_SIGN_CONTRACT',
  FEED_FILTERS = 'FEED_FILTERS',
  INFORMATION_CONFIRMATION = 'INFORMATION_CONFIRMATION',
  INSPECTIONS = 'INSPECTIONS',
  LOAN_APPLICATION = 'LOAN_APPLICATION',
  LOAN_FINALIZATION = 'LOAN_FINALIZATION',
  MARKET_TRENDS = 'MARKET_TRENDS',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
  RESALE_CONTRACT = 'RESALE_CONTRACT',
  UTILITIES = 'UTILITIES'
}

export enum CommissionType {
  FLAT_CENTS = 'FLAT_CENTS',
  RATE_BPS = 'RATE_BPS'
}

export enum DwellingType {
  APARTMENT = 'APARTMENT',
  CHURCH = 'CHURCH',
  COMMERCIAL = 'COMMERCIAL',
  COOP = 'COOP',
  FARM = 'FARM',
  HALF_DUPLEX = 'HALF_DUPLEX',
  HOTEL = 'HOTEL',
  INDUSTRIAL = 'INDUSTRIAL',
  MANUFACTURED = 'MANUFACTURED',
  MIXED = 'MIXED',
  MOBILE_HOME = 'MOBILE_HOME',
  MULTI_FAMILY = 'MULTI_FAMILY',
  OFFICE = 'OFFICE',
  OTHER = 'OTHER',
  RETAIL = 'RETAIL',
  SINGLE_FAMILY = 'SINGLE_FAMILY',
  SPECIAL_PURPOSE = 'SPECIAL_PURPOSE',
  TOWNHOUSE = 'TOWNHOUSE',
  UNKNOWN = 'UNKNOWN',
  VACANT = 'VACANT',
  WAREHOUSE = 'WAREHOUSE'
}

/**
 * `ListValue` is a wrapper around a repeated field of values.
 *
 * The JSON representation for `ListValue` is JSON array.
 */
export type GoogleProtobuf_ListValueInput = {
  /** Repeated field of dynamically typed values. */
  values?: Array<GoogleProtobuf_ValueInput> | null | undefined;
};

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 */
export enum GoogleProtobuf_NullValue {
  /** Null value. */
  NULL_VALUE = 'NULL_VALUE'
}

/**
 * `Struct` represents a structured data value, consisting of fields
 * which map to dynamically typed values. In some languages, `Struct`
 * might be supported by a native representation. For example, in
 * scripting languages like JS a struct is represented as an
 * object. The details of that representation are described together
 * with the proto support for the language.
 *
 * The JSON representation for `Struct` is JSON object.
 */
export type GoogleProtobuf_StructInput = {
  /** Unordered map of dynamically typed values. */
  fields?: Array<GoogleProtobuf_Struct_FieldsEntryInput> | null | undefined;
};

/** `GoogleProtobuf_Struct_FieldsEntryInput` represents the `fields` map in `google.protobuf.Struct`. */
export type GoogleProtobuf_Struct_FieldsEntryInput = {
  key?: string | null | undefined;
  value?: GoogleProtobuf_ValueInput | null | undefined;
};

/**
 * `Value` represents a dynamically typed value which can be either
 * null, a number, a string, a boolean, a recursive struct value, or a
 * list of values. A producer of value is expected to set one of these
 * variants. Absence of any variant indicates an error.
 *
 * The JSON representation for `Value` is JSON value.
 */
export type GoogleProtobuf_ValueInput = {
  /** The kind of value. */
  kind?: GoogleProtobuf_Value_KindOneofInput | null | undefined;
};

export type GoogleProtobuf_Value_KindOneofInput = {
  /** Represents a boolean value. */
  boolValue?: boolean | null | undefined;
  /** Represents a repeated `Value`. */
  listValue?: GoogleProtobuf_ListValueInput | null | undefined;
  /** Represents a null value. */
  nullValue?: GoogleProtobuf_NullValue | null | undefined;
  /** Represents a double value. */
  numberValue?: number | null | undefined;
  /** Represents a string value. */
  stringValue?: string | null | undefined;
  /** Represents a structured value. */
  structValue?: GoogleProtobuf_StructInput | null | undefined;
};

/** Lifecycle states of the post-contract inspection visit. */
export enum InspectionState {
  COMPLETED = 'COMPLETED',
  IN_REVIEW = 'IN_REVIEW',
  NOT_SCHEDULED = 'NOT_SCHEDULED',
  SCHEDULED = 'SCHEDULED'
}

/** From HDS: granite_slab, granite_tile, other_tile, corian, formica, quartz to enum values */
export enum KitchenCountertop {
  CORIAN = 'CORIAN',
  FORMICA = 'FORMICA',
  GRANITE_SLAB = 'GRANITE_SLAB',
  GRANITE_TILE = 'GRANITE_TILE',
  OTHER_TILE = 'OTHER_TILE',
  QUARTZ = 'QUARTZ',
  UNKNOWN = 'UNKNOWN'
}

export enum ListingHistoryState {
  COMING_SOON = 'COMING_SOON',
  FOR_SALE = 'FOR_SALE',
  OFF_MARKET = 'OFF_MARKET',
  PRIVATELY_LISTED = 'PRIVATELY_LISTED',
  SALE_PENDING = 'SALE_PENDING',
  SOLD = 'SOLD',
  TEMP_OFF_MARKET = 'TEMP_OFF_MARKET',
  UNKNOWN = 'UNKNOWN',
  WITHDRAWN = 'WITHDRAWN'
}

/** ListingState represents the current state of a property listing */
export enum ListingState {
  AVAILABLE_SOON = 'AVAILABLE_SOON',
  IN_CONTRACT = 'IN_CONTRACT',
  ON_THE_MARKET = 'ON_THE_MARKET',
  RECENTLY_SOLD = 'RECENTLY_SOLD',
  UNKNOWN = 'UNKNOWN'
}

export enum ListingTag {
  BUY_DIRECT_ELIGIBLE = 'BUY_DIRECT_ELIGIBLE',
  BUY_DIRECT_MULTIPLE_OFFERS = 'BUY_DIRECT_MULTIPLE_OFFERS',
  BUY_DIRECT_SALE_PENDING = 'BUY_DIRECT_SALE_PENDING',
  BUY_DIRECT_VERBAL_AGREEMENT = 'BUY_DIRECT_VERBAL_AGREEMENT'
}

export enum MlsDisplayPermission {
  FULL = 'FULL',
  LIMITED_ADDRESS = 'LIMITED_ADDRESS',
  LIMITED_PHOTO = 'LIMITED_PHOTO',
  NONE = 'NONE'
}

/** From HDS: entry_level, first_floor, second_floor, third_floor, basement to enum values */
export enum MasterBedroomLocation {
  BASEMENT = 'BASEMENT',
  FIRST_FLOOR = 'FIRST_FLOOR',
  SECOND_FLOOR = 'SECOND_FLOOR',
  THIRD_FLOOR = 'THIRD_FLOOR',
  UNKNOWN = 'UNKNOWN'
}

export type MinMaxFilter = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

export type MinMaxFloatFilter = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

/**
 * Why a natural-language search returned zero homes. Null when homes were
 * returned. Clients branch on this to choose the empty-state copy and CTA.
 */
export enum NaturalSearchEmptyReason {
  /** The query is hostile, unsafe, or off-topic. */
  ADVERSARIAL = 'ADVERSARIAL',
  /** The rollout gate is off for this customer, so no downstream search work ran. */
  FEATURE_DISABLED = 'FEATURE_DISABLED',
  /**
   * The query was understood but nothing matched, including over-constrained or
   * unsatisfiable filters.
   */
  NO_MATCHES = 'NO_MATCHES',
  /** The query asks for something the index cannot answer. */
  UNSUPPORTED = 'UNSUPPORTED'
}

/**
 * Buyer-provided feedback fields safe to emit in events.
 * Excludes free_text (may contain PII).
 * Next ID: 6
 */
export type OdProtosBuyerV2Data_TourFeedbackInputInput = {
  /** Aspects the buyer disliked (e.g., "small_bedrooms", "busy_street", "no_garage") */
  dislikedAspects?: Array<string> | null | undefined;
  /** Aspects the buyer liked about the property (e.g., "layout", "kitchen", "backyard") */
  likedAspects?: Array<string> | null | undefined;
  /** Overall sentiment about the tour experience */
  sentiment?: OdProtosBuyerV2Data_TourFeedbackSentiment | null | undefined;
  /** How the feedback was collected */
  source?: OdProtosBuyerV2Data_TourFeedbackSource | null | undefined;
  /** Whether the buyer wants to see similar properties */
  wantsSimilarHomes?: boolean | null | undefined;
};

/** Sentiment expressed by a buyer after completing a tour */
export enum OdProtosBuyerV2Data_TourFeedbackSentiment {
  TOUR_FEEDBACK_SENTIMENT_NEGATIVE = 'TOUR_FEEDBACK_SENTIMENT_NEGATIVE',
  TOUR_FEEDBACK_SENTIMENT_NEUTRAL = 'TOUR_FEEDBACK_SENTIMENT_NEUTRAL',
  TOUR_FEEDBACK_SENTIMENT_POSITIVE = 'TOUR_FEEDBACK_SENTIMENT_POSITIVE',
  TOUR_FEEDBACK_SENTIMENT_UNKNOWN = 'TOUR_FEEDBACK_SENTIMENT_UNKNOWN'
}

/** Source/trigger for collecting the feedback */
export enum OdProtosBuyerV2Data_TourFeedbackSource {
  TOUR_FEEDBACK_SOURCE_EMAIL_PROMPT = 'TOUR_FEEDBACK_SOURCE_EMAIL_PROMPT',
  TOUR_FEEDBACK_SOURCE_MANUAL = 'TOUR_FEEDBACK_SOURCE_MANUAL',
  TOUR_FEEDBACK_SOURCE_MOBILE_CAROUSEL = 'TOUR_FEEDBACK_SOURCE_MOBILE_CAROUSEL',
  TOUR_FEEDBACK_SOURCE_POST_TOUR_MODAL = 'TOUR_FEEDBACK_SOURCE_POST_TOUR_MODAL',
  TOUR_FEEDBACK_SOURCE_PUSH_NOTIFICATION = 'TOUR_FEEDBACK_SOURCE_PUSH_NOTIFICATION',
  TOUR_FEEDBACK_SOURCE_UNKNOWN = 'TOUR_FEEDBACK_SOURCE_UNKNOWN'
}

/** SubmitTourFeedback - Submit feedback after completing a tour */
export type OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequestInput = {
  customerUuid?: string | null | undefined;
  /** Buyer-provided feedback fields safe to emit in events. */
  feedback?: OdProtosBuyerV2Data_TourFeedbackInputInput | null | undefined;
  /**
   * Optional free-form text feedback. This may contain PII and is intentionally not emitted
   * in TourFeedbackEvent.
   */
  freeText?: string | null | undefined;
  /**
   * The home that was toured. Only one identifier should be provided; the server can
   * resolve the others to avoid mismatches between IDs.
   */
  touredHome?: OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneofInput | null | undefined;
  /** Viewing Appointments identifier for the tour booking (preferred over Visitante visit_id). */
  viewingAppointmentId?: string | null | undefined;
};

export type OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneofInput = {
  addressUuid?: string | null | undefined;
  /**
   * Channel identifier for the home (e.g., BuyDirect channel ID).
   * format: UUID string representation
   */
  channelId?: string | null | undefined;
  /** Web listing identifier (od_protos.web.data.Listing.listing_id). */
  listingId?: string | null | undefined;
};

/**
 * The names must be the uppercase versions of the market identifiers in web.
 * Update region.proto if any market is added/removed from here.
 */
export enum OdProtosCommonMarket_Market {
  ALABAMA_OTHER = 'ALABAMA_OTHER',
  ALASKA_OTHER = 'ALASKA_OTHER',
  ALBUQUERQUE_NM = 'ALBUQUERQUE_NM',
  ARIZONA_OTHER = 'ARIZONA_OTHER',
  ARKANSAS_OTHER = 'ARKANSAS_OTHER',
  /** @deprecated No longer supported */
  ASHEVILLE_NC = 'ASHEVILLE_NC',
  ATLANTA = 'ATLANTA',
  AUSTIN = 'AUSTIN',
  /** @deprecated No longer supported */
  BAKERSFIELD_CA = 'BAKERSFIELD_CA',
  BALTIMORE_MD = 'BALTIMORE_MD',
  BIRMINGHAM_AL = 'BIRMINGHAM_AL',
  BOISE = 'BOISE',
  BOSTON_MA = 'BOSTON_MA',
  CALIFORNIA_OTHER = 'CALIFORNIA_OTHER',
  CENTRAL_CALIFORNIA_CA = 'CENTRAL_CALIFORNIA_CA',
  CHARLESTON_SC = 'CHARLESTON_SC',
  CHARLOTTE = 'CHARLOTTE',
  CHATTANOOGA = 'CHATTANOOGA',
  CHICAGO_IL = 'CHICAGO_IL',
  CINCINNATI_OH = 'CINCINNATI_OH',
  /** @deprecated No longer supported */
  CINCINNATI_OK = 'CINCINNATI_OK',
  /** @deprecated No longer supported */
  CLARKSVILLE_KY_TN = 'CLARKSVILLE_KY_TN',
  CLEVELAND_OH = 'CLEVELAND_OH',
  COLORADO_OTHER = 'COLORADO_OTHER',
  COLORADO_SPRINGS_CO = 'COLORADO_SPRINGS_CO',
  COLUMBIA_SC = 'COLUMBIA_SC',
  COLUMBUS_OH = 'COLUMBUS_OH',
  CONNECTICUT_OTHER = 'CONNECTICUT_OTHER',
  CORPUS_CHRISTI_TX = 'CORPUS_CHRISTI_TX',
  DALLAS = 'DALLAS',
  DELAWARE_OTHER = 'DELAWARE_OTHER',
  DENVER = 'DENVER',
  DETROIT_MI = 'DETROIT_MI',
  EAST_TEXAS = 'EAST_TEXAS',
  EL_PASO = 'EL_PASO',
  FLORIDA_PANHANDLE = 'FLORIDA_PANHANDLE',
  /**
   * renamed to NORTHERN_COLORADO
   * @deprecated No longer supported
   */
  FORT_COLLINS_CO = 'FORT_COLLINS_CO',
  GEORGIA_OTHER = 'GEORGIA_OTHER',
  GREENSBORO_NC = 'GREENSBORO_NC',
  GREENVILLE_SC = 'GREENVILLE_SC',
  HAWAII_OTHER = 'HAWAII_OTHER',
  HOUSTON = 'HOUSTON',
  /** @deprecated No longer supported */
  HUNTSVILLE_AL = 'HUNTSVILLE_AL',
  IDAHO_OTHER = 'IDAHO_OTHER',
  ILLINOIS_OTHER = 'ILLINOIS_OTHER',
  INDIANAPOLIS_IN = 'INDIANAPOLIS_IN',
  INDIANA_OTHER = 'INDIANA_OTHER',
  IOWA_OTHER = 'IOWA_OTHER',
  JACKSONVILLE = 'JACKSONVILLE',
  /** @deprecated No longer supported */
  JOHNSON_CITY_TN = 'JOHNSON_CITY_TN',
  KANSAS_CITY = 'KANSAS_CITY',
  KANSAS_OTHER = 'KANSAS_OTHER',
  KENTUCKY_OTHER = 'KENTUCKY_OTHER',
  KILLEEN_TX = 'KILLEEN_TX',
  KNOXVILLE_TN = 'KNOXVILLE_TN',
  LAS_VEGAS = 'LAS_VEGAS',
  LITTLE_ROCK_AR = 'LITTLE_ROCK_AR',
  LOS_ANGELES = 'LOS_ANGELES',
  LOUISIANA_OTHER = 'LOUISIANA_OTHER',
  LOUISVILLE_IN_KY = 'LOUISVILLE_IN_KY',
  MAINE_OTHER = 'MAINE_OTHER',
  MARYLAND_OTHER = 'MARYLAND_OTHER',
  MASSACHUSETTS_OTHER = 'MASSACHUSETTS_OTHER',
  /** Open Exchange only */
  MEMPHIS_TN = 'MEMPHIS_TN',
  MIAMI_FL = 'MIAMI_FL',
  MICHIGAN_OTHER = 'MICHIGAN_OTHER',
  MILWAUKEE_WAUKESHA_WI = 'MILWAUKEE_WAUKESHA_WI',
  MINNEAPOLIS = 'MINNEAPOLIS',
  MINNESOTA_OTHER = 'MINNESOTA_OTHER',
  MISSISSIPPI_OTHER = 'MISSISSIPPI_OTHER',
  MISSOURI_OTHER = 'MISSOURI_OTHER',
  MONTANA_OTHER = 'MONTANA_OTHER',
  NASHVILLE = 'NASHVILLE',
  NEBRASKA_OTHER = 'NEBRASKA_OTHER',
  NEVADA_OTHER = 'NEVADA_OTHER',
  NEW_HAMPSHIRE_OTHER = 'NEW_HAMPSHIRE_OTHER',
  NEW_MEXICO_OTHER = 'NEW_MEXICO_OTHER',
  NEW_ORLEANS_LA = 'NEW_ORLEANS_LA',
  NEW_YORK_NEW_JERSEY = 'NEW_YORK_NEW_JERSEY',
  NEW_YORK_OTHER = 'NEW_YORK_OTHER',
  NORTHERN_COLORADO = 'NORTHERN_COLORADO',
  NORTH_CAROLINA_OTHER = 'NORTH_CAROLINA_OTHER',
  NORTH_DAKOTA_OTHER = 'NORTH_DAKOTA_OTHER',
  OHIO_OTHER = 'OHIO_OTHER',
  OKLAHOMA_CITY_OK = 'OKLAHOMA_CITY_OK',
  OKLAHOMA_OTHER = 'OKLAHOMA_OTHER',
  OMAHA_NE = 'OMAHA_NE',
  OREGON_OTHER = 'OREGON_OTHER',
  ORLANDO = 'ORLANDO',
  /** @deprecated No longer supported */
  PALM_BAY_FL = 'PALM_BAY_FL',
  PENNSYLVANIA_OTHER = 'PENNSYLVANIA_OTHER',
  PHILADELPHIA_PA = 'PHILADELPHIA_PA',
  PHOENIX = 'PHOENIX',
  PITTSBURGH_PA = 'PITTSBURGH_PA',
  PORTLAND = 'PORTLAND',
  PRESCOTT_AZ = 'PRESCOTT_AZ',
  /** @deprecated No longer supported */
  PROVIDENCE_RI = 'PROVIDENCE_RI',
  PUERTO_RICO_OTHER = 'PUERTO_RICO_OTHER',
  RALEIGH = 'RALEIGH',
  RENO_NV = 'RENO_NV',
  RICHMOND_VA = 'RICHMOND_VA',
  RIVERSIDE = 'RIVERSIDE',
  SACRAMENTO = 'SACRAMENTO',
  SALT_LAKE_CITY = 'SALT_LAKE_CITY',
  SAN_ANTONIO = 'SAN_ANTONIO',
  SAN_DIEGO_CA = 'SAN_DIEGO_CA',
  /** @deprecated No longer supported */
  SAVANNAH_GA = 'SAVANNAH_GA',
  SEATTLE_WA = 'SEATTLE_WA',
  SF_BAY_AREA = 'SF_BAY_AREA',
  SOUTHWEST_FL = 'SOUTHWEST_FL',
  SOUTH_CAROLINA_OTHER = 'SOUTH_CAROLINA_OTHER',
  SOUTH_DAKOTA_OTHER = 'SOUTH_DAKOTA_OTHER',
  SOUTH_TEXAS = 'SOUTH_TEXAS',
  /** @deprecated No longer supported */
  SPRINGFIELD_MO = 'SPRINGFIELD_MO',
  ST_LOUIS = 'ST_LOUIS',
  TAMPA = 'TAMPA',
  TENNESSEE_OTHER = 'TENNESSEE_OTHER',
  TUCSON = 'TUCSON',
  TULSA_OK = 'TULSA_OK',
  UNKNOWN = 'UNKNOWN',
  UTAH_OTHER = 'UTAH_OTHER',
  VERMONT_OTHER = 'VERMONT_OTHER',
  VIRGINIA_BEACH_VA = 'VIRGINIA_BEACH_VA',
  VIRGINIA_OTHER = 'VIRGINIA_OTHER',
  WASHINGTON_DC = 'WASHINGTON_DC',
  WASHINGTON_OTHER = 'WASHINGTON_OTHER',
  WESTERN_MD = 'WESTERN_MD',
  WESTERN_NY = 'WESTERN_NY',
  WEST_TEXAS = 'WEST_TEXAS',
  WEST_VIRGINIA_OTHER = 'WEST_VIRGINIA_OTHER',
  /** @deprecated No longer supported */
  WICHITA_KS = 'WICHITA_KS',
  WISCONSIN_OTHER = 'WISCONSIN_OTHER',
  WYOMING_OTHER = 'WYOMING_OTHER'
}

export type OdProtosCommon_DateInput = {
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year/month where the day is not significant.
   */
  day?: number | null | undefined;
  /** Month of year. Must be from 1 to 12. */
  month?: number | null | undefined;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year?: number | null | undefined;
};

/**
 * Classifications for the type of phone number of the Contact.
 *
 * Next ID: 4
 */
export enum OdProtosCustomerV1Data_Phone_PhoneType {
  HOME = 'HOME',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER',
  WORK = 'WORK'
}

/**
 * PreferenceSource identifies what triggered a communication preference or subscription change.
 * Used for audit trail and compliance purposes.
 * Note: initial values are SMS-focused; additional sources for email and call
 * can be added as those flows require preference tracking.
 */
export enum OdProtosCustomerV1Data_PreferenceSource {
  /** Change originated from Cake (customer dashboard / account settings) */
  PREFERENCE_SOURCE_CAKE = 'PREFERENCE_SOURCE_CAKE',
  /** Change originated from Cosmos (opendoor.com marketing site, e.g. the login/signup form) */
  PREFERENCE_SOURCE_COSMOS = 'PREFERENCE_SOURCE_COSMOS',
  /** Change originated from the Iterable UI (e.g. an operator toggling a subscription directly in Iterable) */
  PREFERENCE_SOURCE_ITERABLE_UI = 'PREFERENCE_SOURCE_ITERABLE_UI',
  /** START keyword received on the marketing SMS phone number */
  PREFERENCE_SOURCE_MARKETING_START_COMMAND = 'PREFERENCE_SOURCE_MARKETING_START_COMMAND',
  /** STOP keyword received on the marketing SMS phone number */
  PREFERENCE_SOURCE_MARKETING_STOP_COMMAND = 'PREFERENCE_SOURCE_MARKETING_STOP_COMMAND',
  /** Change made by an operator via internal tooling (e.g. Tessellation) */
  PREFERENCE_SOURCE_OPERATOR = 'PREFERENCE_SOURCE_OPERATOR',
  /** Change originated from Reception (seller onboarding flow) */
  PREFERENCE_SOURCE_RECEPTION = 'PREFERENCE_SOURCE_RECEPTION',
  /** Change originated from a Salesforce sync */
  PREFERENCE_SOURCE_SALESFORCE = 'PREFERENCE_SOURCE_SALESFORCE',
  /** START keyword received on the transactional SMS phone number */
  PREFERENCE_SOURCE_TRANSACTIONAL_START_COMMAND = 'PREFERENCE_SOURCE_TRANSACTIONAL_START_COMMAND',
  /** STOP keyword received on the transactional SMS phone number */
  PREFERENCE_SOURCE_TRANSACTIONAL_STOP_COMMAND = 'PREFERENCE_SOURCE_TRANSACTIONAL_STOP_COMMAND',
  PREFERENCE_SOURCE_UNSPECIFIED = 'PREFERENCE_SOURCE_UNSPECIFIED',
  /** Change made by the Virtual Agent (automated AI system acting on Opendoor's behalf) */
  PREFERENCE_SOURCE_VIRTUAL_AGENT = 'PREFERENCE_SOURCE_VIRTUAL_AGENT'
}

/**
 * Params specifies different parameters to update a Customer on.
 *
 * At least one parameter must be specified.
 *
 * Next ID: 6
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput = {
  emails?: Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_EmailInput> | null | undefined;
  firstName?: string | null | undefined;
  isAgent?: boolean | null | undefined;
  lastName?: string | null | undefined;
  phones?: Array<OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput> | null | undefined;
};

/**
 * Email specifies the email to update/delete/create.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_EmailInput = {
  new?: OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_NewInput | null | undefined;
  old?: OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_OldInput | null | undefined;
};

/**
 * New specifies the new email to update to.
 *
 * If nil is passed in, the customer's old email will be deleted.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_NewInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: string | null | undefined;
  /**
   * make_primary specifies whether or not to set the new email as primary. If a customer has
   * a different email set as primary, it will replace that primary with this new one.
   *
   * Setting make_primary to false will NOT unset an existing primary.
   */
  makePrimary?: boolean | null | undefined;
};

/**
 * Old specifies the old email to update.
 *
 * If nil is passed in for the old email,
 * then a new email will be created based on
 * the new emails parameters.
 *
 * Next ID: 2
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Email_OldInput = {
  /**
   * The e-mail address of this email object. This is also the primary identifier
   * of the email under the context of a specific customer.
   */
  address?: string | null | undefined;
};

/**
 * Phone specifies the phone to update/delete/create.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_PhoneInput = {
  new?: OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_NewInput | null | undefined;
  old?: OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_OldInput | null | undefined;
};

/**
 * New specifies the new phone to update to.
 *
 * If nil is passed in, the customer's old phone will be deleted.
 *
 * Next ID: 4
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_NewInput = {
  /**
   * make_primary specifies whether or not to set the new phone as primary. If a customer has
   * a different phone set as primary, it will replace that primary with this new one.
   *
   * Setting make_primary to false will NOT unset an existing primary.
   */
  makePrimary?: boolean | null | undefined;
  number?: string | null | undefined;
  type?: OdProtosCustomerV1Data_Phone_PhoneType | null | undefined;
};

/**
 * Old specifies the old phone to update.
 *
 * The phone number and the phone type must match the customer's old phone
 * record exactly in order to find the right phone to update.
 *
 * If nil is passed in for the old phone,
 * then a new phone number will be created based on
 * the new phone parameters.
 *
 * Next ID: 3
 */
export type OdProtosCustomerV1Services_CustomerRequests_Update_Params_Phone_OldInput = {
  number?: string | null | undefined;
  type?: OdProtosCustomerV1Data_Phone_PhoneType | null | undefined;
};

export type OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput = {
  /** If call_opt_out is not set, it will not be updated */
  callOptOut?: boolean | null | undefined;
  consentLanguage?: string | null | undefined;
  customerUuid?: string | null | undefined;
  /** If email_opt_out is not set, it will not be updated */
  emailOptOut?: boolean | null | undefined;
  marketingSmsOptOut?: boolean | null | undefined;
  /** Identifies what triggered this preference change. */
  preferenceSource?: OdProtosCustomerV1Data_PreferenceSource | null | undefined;
  /** If sms_opt_out is not set, it will not be updated */
  smsOptOut?: boolean | null | undefined;
  transactionalSmsOptOut?: boolean | null | undefined;
};

export enum OdProtosGeoDataStoreData_EducationLevel {
  EDUCATIONLEVEL_ELEMENTARY = 'EDUCATIONLEVEL_ELEMENTARY',
  EDUCATIONLEVEL_HIGH = 'EDUCATIONLEVEL_HIGH',
  EDUCATIONLEVEL_MIDDLE = 'EDUCATIONLEVEL_MIDDLE',
  EDUCATIONLEVEL_UNKNOWN = 'EDUCATIONLEVEL_UNKNOWN'
}

export enum OdProtosGeoDataStoreData_Zone_Type {
  CITY = 'CITY',
  COUNTY = 'COUNTY',
  MACRO_NEIGHBORHOOD = 'MACRO_NEIGHBORHOOD',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  RESIDENTIAL_BOUNDARY = 'RESIDENTIAL_BOUNDARY',
  STATE = 'STATE',
  SUBNEIGHBORHOOD = 'SUBNEIGHBORHOOD',
  UNKNOWN = 'UNKNOWN',
  ZIP_CODE = 'ZIP_CODE'
}

export enum OdProtosRealtyCommon_Source_Type {
  /** From a homebuilder. */
  HOMEBUILDER = 'HOMEBUILDER',
  /** From a listing agent and off MLS. */
  LISTING_AGENT = 'LISTING_AGENT',
  /** From an MLS. If set, please also set the mls field. */
  MLS = 'MLS',
  /** From Opendoor, when they are selling (e.g. resale). */
  PROP_CO = 'PROP_CO',
  /** From a direct seller who entered their address on the Opendoor seller flow. */
  SELLER_CO = 'SELLER_CO',
  UNKNOWN_TYPE = 'UNKNOWN_TYPE'
}

/**
 * Sell request states define the actions that can be performed on the sell request.
 *
 * Terminal: Sell request cannot receive new buy offers and will not change state under normal
 *   circumstances.
 */
export enum OdProtosRealtyOdlsData_SellRequest_State {
  /**
   * The seller is actively receiving offers.
   * Terminal: No
   */
  SELL_REQUEST_ACTIVE = 'SELL_REQUEST_ACTIVE',
  /**
   * A sale has gone through and is now closed.
   * Terminal: Yes.
   */
  SELL_REQUEST_CLOSED = 'SELL_REQUEST_CLOSED',
  /**
   * The sell request is coming soon.
   * Terminal: No.
   */
  SELL_REQUEST_COMING_SOON = 'SELL_REQUEST_COMING_SOON',
  /**
   * The sell request has expired and is no longer current. This state is set automatically when
   * the sell request expires.
   * Terminal: Yes
   */
  SELL_REQUEST_EXPIRED = 'SELL_REQUEST_EXPIRED',
  /**
   * The sell request is listed privately (aka not on the MLS) (e.g. listed only on exclusives).
   * Terminal: No.
   */
  SELL_REQUEST_PRIVATELY_LISTED = 'SELL_REQUEST_PRIVATELY_LISTED',
  /**
   * A sale is pending.
   * Terminal: No.
   */
  SELL_REQUEST_SALE_PENDING = 'SELL_REQUEST_SALE_PENDING',
  /**
   * The sell request is temporarily off the market.
   * Terminal: No.
   */
  SELL_REQUEST_TEMP_OFF_MARKET = 'SELL_REQUEST_TEMP_OFF_MARKET',
  SELL_REQUEST_UNKNOWN = 'SELL_REQUEST_UNKNOWN',
  /**
   * The seller is not actively receiving offers.
   * Terminal: Yes
   */
  SELL_REQUEST_WITHDRAWN = 'SELL_REQUEST_WITHDRAWN'
}

/**
 * any filters we want to query by, beyond the required zip + market
 * Next ID: 3
 */
export type OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput = {
  bathrooms?: string | null | undefined;
  bedrooms?: string | null | undefined;
};

/**
 * Grain is used to identify the entity that will be bucketed and supports multiple identifiers.
 * Next ID: 4
 */
export type OdProtosVariantData_GrainInput = {
  grain?: OdProtosVariantData_Grain_GrainOneofInput | null | undefined;
  /** Deprecated: use grain instead */
  id?: OdProtosVariantData_Grain_IdOneofInput | null | undefined;
};

export type OdProtosVariantData_Grain_CustomerGrainInput = {
  primaryId?: OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput | null | undefined;
  temporaryId?: OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput | null | undefined;
};

export type OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneofInput = {
  customerUuid?: string | null | undefined;
};

export type OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneofInput = {
  anonymousId?: string | null | undefined;
};

export type OdProtosVariantData_Grain_GrainOneofInput = {
  customer?: OdProtosVariantData_Grain_CustomerGrainInput | null | undefined;
  operator?: OdProtosVariantData_Grain_OperatorGrainInput | null | undefined;
  property?: OdProtosVariantData_Grain_PropertyGrainInput | null | undefined;
};

export type OdProtosVariantData_Grain_IdOneofInput = {
  anonymousId?: string | null | undefined;
  customerUuid?: string | null | undefined;
};

export type OdProtosVariantData_Grain_OperatorGrainInput = {
  primaryId?: OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput | null | undefined;
};

export type OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneofInput = {
  humanToken?: string | null | undefined;
};

export type OdProtosVariantData_Grain_PropertyGrainInput = {
  primaryId?: OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput | null | undefined;
  temporaryId?: OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput | null | undefined;
};

export type OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneofInput = {
  addressToken?: string | null | undefined;
};

export type OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneofInput = {
  propertyEngagementId?: string | null | undefined;
};

export enum OdProtosWebData_ListingOfferDetails_FinancingStatus {
  CASH = 'CASH',
  CONVENTIONAL = 'CONVENTIONAL',
  DONT_KNOW = 'DONT_KNOW',
  FHA_LOAN = 'FHA_LOAN',
  MORTGAGE_PARTNER = 'MORTGAGE_PARTNER',
  TX_VA_LOAN = 'TX_VA_LOAN',
  USDA_LOAN = 'USDA_LOAN',
  VA_LOAN = 'VA_LOAN'
}

/** Next ID: 16 */
export enum OdProtosWebData_Offer_State {
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_OFFER = 'ACCEPTED_OFFER',
  CLOSED = 'CLOSED',
  CONTINGENCY_RELEASED = 'CONTINGENCY_RELEASED',
  DRAFT = 'DRAFT',
  EXPIRED = 'EXPIRED',
  /** final offer is ready, but not yet released to the seller */
  FINAL_OFFER_UNRELEASED = 'FINAL_OFFER_UNRELEASED',
  IN_CONTRACT = 'IN_CONTRACT',
  READY_TO_SEND = 'READY_TO_SEND',
  REQUESTED_TO_LIST = 'REQUESTED_TO_LIST',
  SEND_IN_PROGRESS = 'SEND_IN_PROGRESS',
  SENT = 'SENT',
  /** States all defined in web/app/models/offer.rb */
  UNKNOWN = 'UNKNOWN',
  VIEWING = 'VIEWING',
  /** @deprecated No longer supported */
  WAITING_FOR_LIST_WITH_CERTAINTY = 'WAITING_FOR_LIST_WITH_CERTAINTY',
  /** @deprecated No longer supported */
  WAITING_FOR_OTHER_OFFERS = 'WAITING_FOR_OTHER_OFFERS',
  WITHDRAWN = 'WITHDRAWN'
}

/** Next ID: 7 */
export enum OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn {
  /**
   * Replaced by EARLY_MOVEIN
   * @deprecated No longer supported
   */
  EARLY_CHECKOUT = 'EARLY_CHECKOUT',
  EARLY_MOVEIN = 'EARLY_MOVEIN',
  MOVING_SERVICES = 'MOVING_SERVICES',
  NONE = 'NONE',
  OSN_TITLE_ESCROW = 'OSN_TITLE_ESCROW',
  POWERWALL = 'POWERWALL',
  /**
   * Deprecated: Warranty is available to buyers by default and no longer needs to be selected.
   * @deprecated No longer supported
   */
  WARRANTY = 'WARRANTY'
}

/** Next ID: 4 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput = {
  email?: string | null | undefined;
  name?: string | null | undefined;
  phoneNumber?: string | null | undefined;
};

/** Next ID: 3 */
export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput = {
  name?: string | null | undefined;
  s3Path?: string | null | undefined;
};

export type OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput = {
  /** Finds the latest listing for the address. */
  addressToken?: string | null | undefined;
  listingId?: string | null | undefined;
};

/** Next ID: 2 */
export type OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput = {
  addressToken?: string | null | undefined;
};

export type PageInput = {
  /** Returns the elements in the list that come after the specified cursor. */
  after?: string | null | undefined;
  /** Returns the elements in the list that come before the specified cursor. */
  before?: string | null | undefined;
  /** Returns the first _n_ elements from the list. */
  first?: number | null | undefined;
  /** Returns the last _n_ elements from the list. */
  last?: number | null | undefined;
};

export type PropertyFilters = {
  aboveGradeSqFt?: MinMaxFilter | null | undefined;
  basementSqFt?: MinMaxFilter | null | undefined;
  bathroomsTotal?: MinMaxFloatFilter | null | undefined;
  bedrooms?: MinMaxFilter | null | undefined;
  currentListPrice?: MinMaxFilter | null | undefined;
  dwellingTypes?: Array<string> | null | undefined;
  excludeAddressIds?: Array<string> | null | undefined;
  excludeListingStates?: Array<OdProtosRealtyOdlsData_SellRequest_State> | null | undefined;
  gteIndexedAt?: string | null | undefined;
  gteListedAt?: string | null | undefined;
  gtePendingAt?: string | null | undefined;
  gteSoldAt?: string | null | undefined;
  hasPhotos?: boolean | null | undefined;
  hasPool?: boolean | null | undefined;
  isDisplayable?: boolean | null | undefined;
  isFhaEligible?: boolean | null | undefined;
  isNewConstruction?: boolean | null | undefined;
  isOpendoorOwned?: boolean | null | undefined;
  listingStates?: Array<OdProtosRealtyOdlsData_SellRequest_State> | null | undefined;
  lotSqFt?: MinMaxFilter | null | undefined;
  ltIndexedAt?: string | null | undefined;
  ltListedAt?: string | null | undefined;
  ltPendingAt?: string | null | undefined;
  ltSoldAt?: string | null | undefined;
  monthlyHoaDues?: MinMaxFilter | null | undefined;
  photoThresholdSeconds?: number | null | undefined;
  selfTourAvailable?: boolean | null | undefined;
  soldPrice?: MinMaxFilter | null | undefined;
  stories?: MinMaxFilter | null | undefined;
  subdivision?: string | null | undefined;
  totalLivingSqFt?: MinMaxFilter | null | undefined;
  yearBuilt?: MinMaxFilter | null | undefined;
  zoneIds?: Array<string> | null | undefined;
};

/**
 * This enum captures the comprehensive states that should be presented to a customer.
 * The value can be determined by a combination of different values in the backend across
 * systems. States are organized into phases: Offer Review, Contract Signing, In Contract,
 * and Terminal states (successful or unsuccessful). See app/models/listing_offer.rb in
 * the web repo. Specifically the aasm definition.
 */
export enum TransactionState {
  /**
   * The initial state for an offer
   * :active in the backend
   */
  ACTIVE = 'ACTIVE',
  /**
   * Contract is under attorney review (required in some states)
   * :attorney_review in the backend
   */
  ATTORNEY_REVIEW = 'ATTORNEY_REVIEW',
  /** @deprecated Doesn't map to anything in the backend */
  AWAITING_COUNTERSIGNATURE = 'AWAITING_COUNTERSIGNATURE',
  /**
   * Contract is ready and awaiting buyer's signature
   * :awaiting_signature in the backend
   */
  AWAITING_CUSTOMER_SIGNATURE = 'AWAITING_CUSTOMER_SIGNATURE',
  /**
   * Backup offer expired - home was sold to another buyer
   * :backup_already_sold in the backend
   */
  BACKUP_EXPIRED = 'BACKUP_EXPIRED',
  /**
   * Offer is in backup position behind another accepted offer
   * :backup in the backend
   */
  BACKUP_OFFER = 'BACKUP_OFFER',
  /**
   * Offer was canceled by the buyer
   * :buyer_walked in the backend
   */
  BUYER_WALKED = 'BUYER_WALKED',
  /** @deprecated Use AWAITING_COUNTERSIGNATURE instead */
  BUY_DIRECT_AWAITING_COUNTERSIGNATURE = 'BUY_DIRECT_AWAITING_COUNTERSIGNATURE',
  /** @deprecated Use BACKUP_OFFER instead */
  BUY_DIRECT_BACKUP = 'BUY_DIRECT_BACKUP',
  /** @deprecated Use IN_CONTRACT instead */
  BUY_DIRECT_IN_CONTRACT = 'BUY_DIRECT_IN_CONTRACT',
  /** @deprecated Use AWAITING_SIGNATURE instead */
  BUY_DIRECT_UNSIGNED_CONTRACT = 'BUY_DIRECT_UNSIGNED_CONTRACT',
  /**
   * Offer was canceled
   * :canceled in the backend
   */
  CANCELED = 'CANCELED',
  /** @deprecated Use CANCELED instead */
  CANCELED_OFFER = 'CANCELED_OFFER',
  /** @deprecated Use CLOSED instead */
  CLOSE = 'CLOSE',
  /**
   * Transaction completed successfully - buyer now owns the home
   * :closed in the backend
   */
  CLOSED = 'CLOSED',
  /**
   * All contingencies have been released - final steps before close
   * :contingency_released in the backend
   */
  CONTINGENCIES_RELEASED = 'CONTINGENCIES_RELEASED',
  /**
   * Contract fell through after being in contract
   * :contract_fell_through in the backend
   */
  CONTRACT_FELL_THROUGH = 'CONTRACT_FELL_THROUGH',
  /**
   * Opendoor has made a counter offer - buyer action required
   * :countered in the backend
   */
  COUNTER_OFFER_PENDING = 'COUNTER_OFFER_PENDING',
  /**
   * Contract is fully executed and active - proceeding toward close
   * :in_contract in the backend
   */
  IN_CONTRACT = 'IN_CONTRACT',
  /**
   * Offer is being actively negotiated between buyer and Opendoor
   * :in_negotiation in the backend
   */
  IN_NEGOTIATION = 'IN_NEGOTIATION',
  /** @deprecated Doesn't map to anything in the backend */
  PENDING_REVIEW = 'PENDING_REVIEW',
  /**
   * Offer was rejected by Opendoor
   * :rejected in the backend
   */
  REJECTED = 'REJECTED',
  /** Catch-all state if we're unable to map the backend state */
  UNKNOWN = 'UNKNOWN'
}

export type PropertyDetailsFragment_MarketplaceProperty_hoas_Hoa = {
  __typename: 'Hoa',
  name: string | null,
  feeAmount: number | null,
  feeFrequency: string | null
};

export type PropertyDetailsFragment_MarketplaceProperty_listingHistory_MarketplaceListingHistory = {
  __typename: 'MarketplaceListingHistory',
  state: ListingHistoryState | null,
  timestamp: string | null,
  mls: string | null,
  originalListPriceCents: number | null,
  soldPriceCents: number | null,
  currentListPriceCents: number | null
};

export type PropertyDetailsFragment_MarketplaceProperty_listingMetadata_ListingMetadata = {
  __typename: 'ListingMetadata',
  buyDirectDiscountPercent: number | null
};

export type PropertyDetailsFragment_MarketplaceProperty_floorPlanPhotos_MarketplaceFloorPlanPhoto = {
  __typename: 'MarketplaceFloorPlanPhoto',
  url: string,
  label: string
};

export type PropertyDetailsFragment_MarketplaceProperty_schools_MarketplaceSchool = {
  __typename: 'MarketplaceSchool',
  id: string,
  name: string,
  rating: number | null
};

export type PropertyDetailsFragment_MarketplaceProperty_similarProperties_MarketplacePropertyListQueryResult_results_MarketplacePropertyListResult = {
  __typename: 'MarketplacePropertyListResult',
  id: string,
  addressToken: string | null,
  baths: number | null,
  beds: number | null,
  city: string | null,
  dwellingType: DwellingType | null,
  fullAddress: string | null,
  listPrice: number | null,
  livingSquareFootage: number | null,
  neighborhood: string | null,
  slug: string | null,
  photos: Array<string> | null
};

export type PropertyDetailsFragment_MarketplaceProperty_similarProperties_MarketplacePropertyListQueryResult = {
  __typename: 'MarketplacePropertyListQueryResult',
  count: number,
  nextPage: number | null,
  results: Array<PropertyDetailsFragment_MarketplaceProperty_similarProperties_MarketplacePropertyListQueryResult_results_MarketplacePropertyListResult> | null
};

export type PropertyDetailsFragment = {
  __typename: 'MarketplaceProperty',
  addressToken: string,
  bathrooms: number | null,
  bedrooms: number | null,
  buyDirectPrice: number | null,
  canSelfTour: boolean | null,
  city: string,
  cumulativeDaysOnMarket: number | null,
  daysOnMarket: number | null,
  description: string | null,
  displayBadge: Badge | null,
  dwellingType: DwellingType | null,
  estimatedMonthlyPayment: number | null,
  exteriorStories: number | null,
  fhaEligible: boolean | null,
  fhaEligibleDate: string | null,
  garageSpaces: number | null,
  hasPrivatePool: boolean | null,
  hasCommunityPool: boolean | null,
  inGatedCommunity: boolean | null,
  kitchenCountertop: KitchenCountertop | null,
  latitude: number,
  longitude: number,
  listPrice: number | null,
  estimatedBuyDirectMonthlyPayment: number | null,
  listingState: ListingState | null,
  listingTags: Array<ListingTag> | null,
  market: string | null,
  masterBedroomLocation: MasterBedroomLocation | null,
  photos: Array<string> | null,
  photosLg: Array<string | null> | null,
  photosXl: Array<string | null> | null,
  pricePerSqFt: number | null,
  shouldShowGuarantee: boolean,
  schoolDistricts: Array<string> | null,
  sellerDisclosuresDownloadUrl: string | null,
  slug: string,
  sqFtLot: number | null,
  sqFtTotalLiving: number | null,
  state: string | null,
  street: string | null,
  subdivision: string | null,
  unitType: string | null,
  unitNumber: string | null,
  yearBuilt: string | null,
  zip: string | null,
  hoas: Array<PropertyDetailsFragment_MarketplaceProperty_hoas_Hoa> | null,
  listingHistory: Array<PropertyDetailsFragment_MarketplaceProperty_listingHistory_MarketplaceListingHistory> | null,
  listingMetadata: PropertyDetailsFragment_MarketplaceProperty_listingMetadata_ListingMetadata | null,
  floorPlanPhotos: Array<PropertyDetailsFragment_MarketplaceProperty_floorPlanPhotos_MarketplaceFloorPlanPhoto> | null,
  schools: Array<PropertyDetailsFragment_MarketplaceProperty_schools_MarketplaceSchool> | null,
  similarProperties: PropertyDetailsFragment_MarketplaceProperty_similarProperties_MarketplacePropertyListQueryResult | null
};

export type SimilarPropertiesFragment = {
  __typename: 'MarketplacePropertyListQueryResult',
  count: number,
  nextPage: number | null,
  results: Array<PropertyDetailsFragment_MarketplaceProperty_similarProperties_MarketplacePropertyListQueryResult_results_MarketplacePropertyListResult> | null
};

export type SimilarPropertyFragment = {
  __typename: 'MarketplacePropertyListResult',
  id: string,
  addressToken: string | null,
  baths: number | null,
  beds: number | null,
  city: string | null,
  dwellingType: DwellingType | null,
  fullAddress: string | null,
  listPrice: number | null,
  livingSquareFootage: number | null,
  neighborhood: string | null,
  slug: string | null,
  photos: Array<string> | null
};

export type PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl = {
  __typename: 'PhotoUrl',
  resizable: string
};

export type PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto = {
  __typename: 'PropertyPhoto',
  id: string,
  urls: PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl | null
};

export type PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection = {
  __typename: 'PhotoConnection',
  nodes: Array<PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto> | null
};

export type PropertiesByMarketResultFragment = {
  __typename: 'PropertySearchResult',
  displaySlug: string,
  bedrooms: number | null,
  bathroomsTotal: number | null,
  originalListPrice: number | null,
  sqFtTotalLiving: number | null,
  sqFtAboveGrade: number | null,
  listPrice: number | null,
  listTimestamp: string | null,
  street: string,
  unitType: string | null,
  unitNumber: string | null,
  city: string,
  state: string,
  postalCode: string,
  longitude: number,
  latitude: number,
  sqFtLot: number | null,
  addressId: string,
  photos: PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection | null
};

export type MarketplacePropertyListResultFragment = {
  __typename: 'MarketplacePropertyListResult',
  id: string,
  addressToken: string | null,
  badges: Array<Badge> | null,
  beds: number | null,
  baths: number | null,
  city: string | null,
  dwellingType: DwellingType | null,
  fullAddress: string | null,
  isLiked: boolean | null,
  listDate: string | null,
  listPrice: number | null,
  livingSquareFootage: number | null,
  listingState: ListingState | null,
  neighborhood: string | null,
  photos: Array<string> | null,
  slug: string | null,
  state: string | null,
  street: string | null,
  zip: string | null
};

export type UnsubscribeMailerMutation_marketing_OdProtosWebServicesMarketing_Marketing_Mutation_unsubscribeMailer_OdProtosWebServicesMarketing_UnsubscribeMailerResponse = {
  __typename: 'OdProtosWebServicesMarketing_UnsubscribeMailerResponse',
  _empty: boolean | null
};

export type UnsubscribeMailerMutation_marketing_OdProtosWebServicesMarketing_Marketing_Mutation = {
  __typename: 'OdProtosWebServicesMarketing_Marketing_Mutation',
  unsubscribeMailer: UnsubscribeMailerMutation_marketing_OdProtosWebServicesMarketing_Marketing_Mutation_unsubscribeMailer_OdProtosWebServicesMarketing_UnsubscribeMailerResponse | null
};

export type UnsubscribeMailerMutation_Mutation = {
  marketing: UnsubscribeMailerMutation_marketing_OdProtosWebServicesMarketing_Marketing_Mutation
};


export type UnsubscribeMailerMutationVariables = Exact<{
  address: OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput;
}>;


export type UnsubscribeMailerMutation = UnsubscribeMailerMutation_Mutation;

export type UpsertCommPreferenceMutation_customerCommPreferences_OdProtosCustomerV1Services_CustomerCommPreferences_Mutation_upsertCommPreference_OdProtosCustomerV1Services_UpsertCommPreferenceResponse_commPreference_OdProtosCustomerV1Data_CommPreference = {
  __typename: 'OdProtosCustomerV1Data_CommPreference'
};

export type UpsertCommPreferenceMutation_customerCommPreferences_OdProtosCustomerV1Services_CustomerCommPreferences_Mutation_upsertCommPreference_OdProtosCustomerV1Services_UpsertCommPreferenceResponse = {
  __typename: 'OdProtosCustomerV1Services_UpsertCommPreferenceResponse',
  commPreference: UpsertCommPreferenceMutation_customerCommPreferences_OdProtosCustomerV1Services_CustomerCommPreferences_Mutation_upsertCommPreference_OdProtosCustomerV1Services_UpsertCommPreferenceResponse_commPreference_OdProtosCustomerV1Data_CommPreference | null
};

export type UpsertCommPreferenceMutation_customerCommPreferences_OdProtosCustomerV1Services_CustomerCommPreferences_Mutation = {
  __typename: 'OdProtosCustomerV1Services_CustomerCommPreferences_Mutation',
  upsertCommPreference: UpsertCommPreferenceMutation_customerCommPreferences_OdProtosCustomerV1Services_CustomerCommPreferences_Mutation_upsertCommPreference_OdProtosCustomerV1Services_UpsertCommPreferenceResponse | null
};

export type UpsertCommPreferenceMutation_Mutation = {
  customerCommPreferences: UpsertCommPreferenceMutation_customerCommPreferences_OdProtosCustomerV1Services_CustomerCommPreferences_Mutation
};


export type UpsertCommPreferenceMutationVariables = Exact<{
  input: OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput;
}>;


export type UpsertCommPreferenceMutation = UpsertCommPreferenceMutation_Mutation;

export type SubmitTourFeedbackMutation_buyerService_OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation_submitTourFeedback_OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackResponse_feedback_OdProtosBuyerV2Data_TourFeedback = {
  __typename: 'OdProtosBuyerV2Data_TourFeedback',
  tourFeedbackUuid: string,
  viewingAppointmentId: string,
  sentiment: OdProtosBuyerV2Data_TourFeedbackSentiment
};

export type SubmitTourFeedbackMutation_buyerService_OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation_submitTourFeedback_OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackResponse = {
  __typename: 'OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackResponse',
  feedback: SubmitTourFeedbackMutation_buyerService_OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation_submitTourFeedback_OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackResponse_feedback_OdProtosBuyerV2Data_TourFeedback | null
};

export type SubmitTourFeedbackMutation_buyerService_OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation = {
  __typename: 'OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation',
  submitTourFeedback: SubmitTourFeedbackMutation_buyerService_OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation_submitTourFeedback_OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackResponse | null
};

export type SubmitTourFeedbackMutation_Mutation = {
  buyerService: SubmitTourFeedbackMutation_buyerService_OdProtosBuyerV2ServicesBuyer_BuyerService_Mutation
};


export type SubmitTourFeedbackMutationVariables = Exact<{
  input: OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequestInput;
}>;


export type SubmitTourFeedbackMutation = SubmitTourFeedbackMutation_Mutation;

export type SetImpressionMutation_variant_OdProtosVariantServices_Variant_Mutation_setImpression_OdProtosVariantServices_SetImpressionResponse = {
  __typename: 'OdProtosVariantServices_SetImpressionResponse',
  _empty: boolean | null
};

export type SetImpressionMutation_variant_OdProtosVariantServices_Variant_Mutation = {
  __typename: 'OdProtosVariantServices_Variant_Mutation',
  setImpression: SetImpressionMutation_variant_OdProtosVariantServices_Variant_Mutation_setImpression_OdProtosVariantServices_SetImpressionResponse | null
};

export type SetImpressionMutation_Mutation = {
  variant: SetImpressionMutation_variant_OdProtosVariantServices_Variant_Mutation
};


export type SetImpressionMutationVariables = Exact<{
  grain?: OdProtosVariantData_GrainInput | null | undefined;
  key: string;
  variantValue: string;
}>;


export type SetImpressionMutation = SetImpressionMutation_Mutation;

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress = {
  __typename: 'OdProtosCommon_EmailAddress',
  value: string
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email = {
  __typename: 'OdProtosCustomerV1Data_Email',
  address: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress | null
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress = {
  __typename: 'OdProtosCommon_EmailAddress',
  value: string
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email = {
  __typename: 'OdProtosCustomerV1Data_Email',
  address: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress | null
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber = {
  __typename: 'OdProtosCommon_PhoneNumber',
  value: string
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone = {
  __typename: 'OdProtosCustomerV1Data_Phone',
  type: OdProtosCustomerV1Data_Phone_PhoneType,
  number: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber | null
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber = {
  __typename: 'OdProtosCommon_PhoneNumber',
  value: string
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone = {
  __typename: 'OdProtosCustomerV1Data_Phone',
  type: OdProtosCustomerV1Data_Phone_PhoneType,
  number: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber | null
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer = {
  __typename: 'OdProtosCustomerV1Data_Customer',
  uuid: string,
  createdAt: string | null,
  firstName: string,
  lastName: string,
  isAgent: boolean,
  ccpaSaleOfDataOptOut: boolean,
  fullName: string | null,
  primaryEmail: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email | null,
  otherEmails: Array<UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email>,
  primaryPhoneNumber: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone | null,
  otherPhoneNumbers: Array<UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone>
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update = {
  __typename: 'OdProtosCustomerV1Services_CustomerResponses_Update',
  updatedCustomer: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update_updatedCustomer_OdProtosCustomerV1Data_Customer | null
};

export type UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation = {
  __typename: 'OdProtosCustomerV1Services_Customer_Mutation',
  update: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation_update_OdProtosCustomerV1Services_CustomerResponses_Update | null
};

export type UpdateCustomerMutation_Mutation = {
  customerService: UpdateCustomerMutation_customerService_OdProtosCustomerV1Services_Customer_Mutation
};


export type UpdateCustomerMutationVariables = Exact<{
  customerUuid: string;
  params: OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput;
}>;


export type UpdateCustomerMutation = UpdateCustomerMutation_Mutation;

export type CreateViewingAppointmentMutation_web_WebMutation_createViewingAppointment_WebViewingAppointment = {
  __typename: 'WebViewingAppointment',
  id: string
};

export type CreateViewingAppointmentMutation_web_WebMutation = {
  __typename: 'WebMutation',
  createViewingAppointment: CreateViewingAppointmentMutation_web_WebMutation_createViewingAppointment_WebViewingAppointment | null
};

export type CreateViewingAppointmentMutation_Mutation = {
  web: CreateViewingAppointmentMutation_web_WebMutation
};


export type CreateViewingAppointmentMutationVariables = Exact<{
  customerUUID: string;
  appointmentDate: string;
  appointmentTime: string;
  listingId?: number | null | undefined;
  duration?: number | null | undefined;
}>;


export type CreateViewingAppointmentMutation = CreateViewingAppointmentMutation_Mutation;

export type UploadAgentPhotoMutation_external_ExternalMutation_aws_AwsMutation_s3CreatePutObjectPresignedUrl_S3CreatePutObjectPresignedUrlResult = {
  __typename: 'S3CreatePutObjectPresignedUrlResult',
  signedUrl: string,
  key: string
};

export type UploadAgentPhotoMutation_external_ExternalMutation_aws_AwsMutation = {
  __typename: 'AwsMutation',
  s3CreatePutObjectPresignedUrl: UploadAgentPhotoMutation_external_ExternalMutation_aws_AwsMutation_s3CreatePutObjectPresignedUrl_S3CreatePutObjectPresignedUrlResult
};

export type UploadAgentPhotoMutation_external_ExternalMutation = {
  __typename: 'ExternalMutation',
  aws: UploadAgentPhotoMutation_external_ExternalMutation_aws_AwsMutation | null
};

export type UploadAgentPhotoMutation_Mutation = {
  external: UploadAgentPhotoMutation_external_ExternalMutation
};


export type UploadAgentPhotoMutationVariables = Exact<{
  key: string;
}>;


export type UploadAgentPhotoMutation = UploadAgentPhotoMutation_Mutation;

export type CreateBuyDirectListingOfferMutation_webBuyDirectListingOffer_OdProtosWebServicesBuyDirect_ListingOffer_Mutation_createBuyDirectOffer_OdProtosWebServicesBuyDirect_Responses_CreateBuyDirectOffer = {
  __typename: 'OdProtosWebServicesBuyDirect_Responses_CreateBuyDirectOffer',
  listingOfferId: number,
  listingOfferUuid: string,
  contractSignatureId: string
};

export type CreateBuyDirectListingOfferMutation_webBuyDirectListingOffer_OdProtosWebServicesBuyDirect_ListingOffer_Mutation = {
  __typename: 'OdProtosWebServicesBuyDirect_ListingOffer_Mutation',
  createBuyDirectOffer: CreateBuyDirectListingOfferMutation_webBuyDirectListingOffer_OdProtosWebServicesBuyDirect_ListingOffer_Mutation_createBuyDirectOffer_OdProtosWebServicesBuyDirect_Responses_CreateBuyDirectOffer | null
};

export type CreateBuyDirectListingOfferMutation_Mutation = {
  webBuyDirectListingOffer: CreateBuyDirectListingOfferMutation_webBuyDirectListingOffer_OdProtosWebServicesBuyDirect_ListingOffer_Mutation
};


export type CreateBuyDirectListingOfferMutationVariables = Exact<{
  buyer: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput;
  coBuyer?: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput | null | undefined;
  downPaymentCents?: number | null | undefined;
  financingType?: OdProtosWebData_ListingOfferDetails_FinancingStatus | null | undefined;
  closeOfEscrow?: OdProtosCommon_DateInput | null | undefined;
  preApprovalLetter?: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput | null | undefined;
  listing?: OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput | null | undefined;
  addOns?: Array<OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn> | OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn | null | undefined;
  tradeInAddress?: string | null | undefined;
  requestedHeroesHomeCredit?: boolean | null | undefined;
}>;


export type CreateBuyDirectListingOfferMutation = CreateBuyDirectListingOfferMutation_Mutation;

export type GetSchoolsQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_getSchools_OdProtosGeoDataStoreServices_GetSchoolsResponse_schools_OdProtosGeoDataStoreData_School = {
  __typename: 'OdProtosGeoDataStoreData_School',
  name: string,
  rating: number | null,
  educationLevel: Array<OdProtosGeoDataStoreData_EducationLevel>,
  greatSchoolsUrl: string
};

export type GetSchoolsQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_getSchools_OdProtosGeoDataStoreServices_GetSchoolsResponse = {
  __typename: 'OdProtosGeoDataStoreServices_GetSchoolsResponse',
  schools: Array<GetSchoolsQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_getSchools_OdProtosGeoDataStoreServices_GetSchoolsResponse_schools_OdProtosGeoDataStoreData_School>
};

export type GetSchoolsQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query = {
  __typename: 'OdProtosGeoDataStoreServices_GeoDataStore_Query',
  getSchools: GetSchoolsQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_getSchools_OdProtosGeoDataStoreServices_GetSchoolsResponse | null
};

export type GetSchoolsQuery_Query = {
  geoDataStore: GetSchoolsQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query
};


export type GetSchoolsQueryVariables = Exact<{
  latitude: number;
  longitude: number;
}>;


export type GetSchoolsQuery = GetSchoolsQuery_Query;

export type GetPropertyStatusForRouteQuery_property_PropertyQuery_property_Property = {
  __typename: 'Property',
  addressId: string,
  displaySlug: string,
  isDisplayable: boolean,
  odMarketIdentifier: OdProtosCommonMarket_Market | null
};

export type GetPropertyStatusForRouteQuery_property_PropertyQuery = {
  __typename: 'PropertyQuery',
  property: GetPropertyStatusForRouteQuery_property_PropertyQuery_property_Property | null
};

export type GetPropertyStatusForRouteQuery_Query = {
  property: GetPropertyStatusForRouteQuery_property_PropertyQuery
};


export type GetPropertyStatusForRouteQueryVariables = Exact<{
  addressId: string;
}>;


export type GetPropertyStatusForRouteQuery = GetPropertyStatusForRouteQuery_Query;

export type GetAddressForIdQuery_casa_OdProtosCasaServices_Casa_Query_find_OdProtosCasaServices_CasaResponse_Find_address_OdProtosCasaData_Address = {
  __typename: 'OdProtosCasaData_Address',
  street: string,
  unitNumber: string,
  city: string,
  state: string,
  postalCode: string
};

export type GetAddressForIdQuery_casa_OdProtosCasaServices_Casa_Query_find_OdProtosCasaServices_CasaResponse_Find = {
  __typename: 'OdProtosCasaServices_CasaResponse_Find',
  address: GetAddressForIdQuery_casa_OdProtosCasaServices_Casa_Query_find_OdProtosCasaServices_CasaResponse_Find_address_OdProtosCasaData_Address | null
};

export type GetAddressForIdQuery_casa_OdProtosCasaServices_Casa_Query = {
  __typename: 'OdProtosCasaServices_Casa_Query',
  find: GetAddressForIdQuery_casa_OdProtosCasaServices_Casa_Query_find_OdProtosCasaServices_CasaResponse_Find | null
};

export type GetAddressForIdQuery_Query = {
  casa: GetAddressForIdQuery_casa_OdProtosCasaServices_Casa_Query
};


export type GetAddressForIdQueryVariables = Exact<{
  addressId: string;
}>;


export type GetAddressForIdQuery = GetAddressForIdQuery_Query;

export type GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_listingMetadata_ListingMetadata = {
  __typename: 'ListingMetadata',
  tags: Array<ListingTag> | null,
  buyDirectDiscountPercent: number | null
};

export type GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_hoas_Hoa = {
  __typename: 'Hoa',
  name: string | null,
  feeAmount: number | null,
  feeFrequency: string | null,
  features: Array<string | null> | null
};

export type GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl = {
  __typename: 'PhotoUrl',
  resizable: string
};

export type GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto = {
  __typename: 'PropertyPhoto',
  id: string,
  urls: GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl | null
};

export type GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection = {
  __typename: 'PhotoConnection',
  nodes: Array<GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto> | null
};

export type GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property = {
  __typename: 'Property',
  addressId: string,
  sellRequestId: string | null,
  displaySlug: string,
  bathroomsHalf: number | null,
  bathroomsFull: number | null,
  bedrooms: number | null,
  listPrice: number | null,
  status: OdProtosRealtyOdlsData_SellRequest_State | null,
  sqFtTotalLiving: number | null,
  sqFtAboveGrade: number | null,
  sqFtLot: number | null,
  yearBuilt: number | null,
  poolFeatures: Array<string> | null,
  publicRemarks: string | null,
  garageSpaces: number | null,
  sourceType: OdProtosRealtyCommon_Source_Type | null,
  listingMetadata: GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_listingMetadata_ListingMetadata | null,
  hoas: Array<GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_hoas_Hoa> | null,
  photos: GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection | null
};

export type GetShortListingPropertyInfoQuery_property_PropertyQuery = {
  __typename: 'PropertyQuery',
  property: GetShortListingPropertyInfoQuery_property_PropertyQuery_property_Property | null
};

export type GetShortListingPropertyInfoQuery_Query = {
  property: GetShortListingPropertyInfoQuery_property_PropertyQuery
};


export type GetShortListingPropertyInfoQueryVariables = Exact<{
  addressId: string;
}>;


export type GetShortListingPropertyInfoQuery = GetShortListingPropertyInfoQuery_Query;

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_listingMetadata_ListingMetadata = {
  __typename: 'ListingMetadata',
  tags: Array<ListingTag> | null,
  buyDirectDiscountPercent: number | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_hoas_Hoa = {
  __typename: 'Hoa',
  name: string | null,
  feeAmount: number | null,
  feeFrequency: string | null,
  features: Array<string | null> | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_agent_MLSAgent = {
  __typename: 'MLSAgent',
  brokerage: string | null,
  firstName: string | null,
  lastName: string | null,
  fullName: string | null,
  licenseNumber: string | null,
  mls: string | null,
  mlsId: string | null,
  email: string | null,
  phoneNumber: string | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_mls_MLS_logoRequiredDimensions_Dimensions = {
  __typename: 'Dimensions',
  width: number,
  height: number
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_mls_MLS = {
  __typename: 'MLS',
  identifier: string,
  logoUrl: string | null,
  legalText: string | null,
  detailPageLogo: boolean | null,
  detailPageLegalText: boolean | null,
  detailPageAgentOffice: boolean | null,
  detailPageAgentName: boolean | null,
  detailPageMLSNumber: boolean | null,
  detailPageContactInfo: boolean | null,
  logoRequiredDimensions: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_mls_MLS_logoRequiredDimensions_Dimensions | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_schools_School = {
  __typename: 'School',
  id: string,
  name: string,
  rating: string,
  gradesOffered: Array<string> | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_zones_PropertyZone = {
  __typename: 'PropertyZone',
  id: string,
  name: string,
  mapPageSlug: string
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl = {
  __typename: 'PhotoUrl',
  resizable: string
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto = {
  __typename: 'PropertyPhoto',
  id: string,
  urls: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult_photos_PhotoConnection = {
  __typename: 'PhotoConnection',
  nodes: Array<GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult_photos_PhotoConnection_nodes_PropertyPhoto> | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult = {
  __typename: 'PropertySearchResult',
  addressId: string,
  displaySlug: string,
  city: string,
  postalCode: string,
  state: string,
  street: string,
  unitNumber: string | null,
  unitType: string | null,
  bedrooms: number | null,
  bathroomsTotal: number | null,
  listPrice: number | null,
  listTimestamp: string | null,
  status: OdProtosRealtyOdlsData_SellRequest_State | null,
  sqFtLot: number | null,
  sqFtTotalLiving: number | null,
  sqFtAboveGrade: number | null,
  latitude: number,
  longitude: number,
  photos: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult_photos_PhotoConnection | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection = {
  __typename: 'PropertySearchResultConnection',
  nodes: Array<GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult> | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults = {
  __typename: 'PropertySearchResults',
  results: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults_results_PropertySearchResultConnection | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl = {
  __typename: 'PhotoUrl',
  resizable: string
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto = {
  __typename: 'PropertyPhoto',
  id: string,
  urls: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection = {
  __typename: 'PhotoConnection',
  nodes: Array<GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection_nodes_PropertyPhoto> | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_commissionBreakdown_CommissionBreakdown_buyer_Commission = {
  __typename: 'Commission',
  value: number | null,
  type: CommissionType | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_commissionBreakdown_CommissionBreakdown = {
  __typename: 'CommissionBreakdown',
  buyer: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_commissionBreakdown_CommissionBreakdown_buyer_Commission | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property = {
  __typename: 'Property',
  addressId: string,
  odMarketIdentifier: OdProtosCommonMarket_Market | null,
  statePropertyTaxRate: number | null,
  sellRequestId: string | null,
  city: string,
  displaySlug: string,
  postalCode: string,
  state: string,
  street: string,
  county: string,
  unitNumber: string | null,
  unitType: string | null,
  dwellingType: DwellingType,
  bedrooms: number | null,
  bathroomsHalf: number | null,
  bathroomsFull: number | null,
  builderName: string | null,
  exteriorStories: number | null,
  sellerDisclosuresDownloadUrl: string | null,
  listPrice: number | null,
  listTimestamp: string | null,
  status: OdProtosRealtyOdlsData_SellRequest_State | null,
  sqFtTotalLiving: number | null,
  sqFtAboveGrade: number | null,
  sqFtLot: number | null,
  yearBuilt: number | null,
  poolFeatures: Array<string> | null,
  publicRemarks: string | null,
  inGatedCommunity: boolean | null,
  listingOfficeName: string | null,
  apn: string | null,
  mlsDisplayPermission: MlsDisplayPermission | null,
  mlsNumber: string | null,
  entryTimestamp: string | null,
  sellRequestCreatedAt: string | null,
  newConstruction: boolean | null,
  opendoorOwned: boolean,
  instantTourable: boolean | null,
  sourceType: OdProtosRealtyCommon_Source_Type | null,
  latitude: number,
  longitude: number,
  listingMetadata: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_listingMetadata_ListingMetadata | null,
  hoas: Array<GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_hoas_Hoa> | null,
  agent: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_agent_MLSAgent | null,
  mls: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_mls_MLS | null,
  schools: Array<GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_schools_School> | null,
  zones: Array<GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_zones_PropertyZone> | null,
  similarListings: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_similarListings_PropertySearchResults | null,
  photos: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_photos_PhotoConnection | null,
  commissionBreakdown: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property_commissionBreakdown_CommissionBreakdown | null
};

export type GetLongListingPropertyInfoQuery_property_PropertyQuery = {
  __typename: 'PropertyQuery',
  property: GetLongListingPropertyInfoQuery_property_PropertyQuery_property_Property | null
};

export type GetLongListingPropertyInfoQuery_Query = {
  property: GetLongListingPropertyInfoQuery_property_PropertyQuery
};


export type GetLongListingPropertyInfoQueryVariables = Exact<{
  addressId: string;
}>;


export type GetLongListingPropertyInfoQuery = GetLongListingPropertyInfoQuery_Query;

export type GetPropertiesByMarketQuery_property_PropertyQuery_geoSearch_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult = {
  __typename: 'PropertySearchResult',
  displaySlug: string,
  bedrooms: number | null,
  bathroomsTotal: number | null,
  originalListPrice: number | null,
  sqFtTotalLiving: number | null,
  sqFtAboveGrade: number | null,
  listPrice: number | null,
  listTimestamp: string | null,
  street: string,
  unitType: string | null,
  unitNumber: string | null,
  city: string,
  state: string,
  postalCode: string,
  longitude: number,
  latitude: number,
  sqFtLot: number | null,
  addressId: string,
  photos: PropertiesByMarketResultFragment_PropertySearchResult_photos_PhotoConnection | null
};

export type GetPropertiesByMarketQuery_property_PropertyQuery_geoSearch_PropertySearchResults_results_PropertySearchResultConnection = {
  __typename: 'PropertySearchResultConnection',
  nodes: Array<GetPropertiesByMarketQuery_property_PropertyQuery_geoSearch_PropertySearchResults_results_PropertySearchResultConnection_nodes_PropertySearchResult> | null
};

export type GetPropertiesByMarketQuery_property_PropertyQuery_geoSearch_PropertySearchResults = {
  __typename: 'PropertySearchResults',
  results: GetPropertiesByMarketQuery_property_PropertyQuery_geoSearch_PropertySearchResults_results_PropertySearchResultConnection | null
};

export type GetPropertiesByMarketQuery_property_PropertyQuery = {
  __typename: 'PropertyQuery',
  geoSearch: GetPropertiesByMarketQuery_property_PropertyQuery_geoSearch_PropertySearchResults
};

export type GetPropertiesByMarketQuery_Query = {
  property: GetPropertiesByMarketQuery_property_PropertyQuery
};


export type GetPropertiesByMarketQueryVariables = Exact<{
  shape: string;
  filters?: PropertyFilters | null | undefined;
  pageInput: PageInput;
}>;


export type GetPropertiesByMarketQuery = GetPropertiesByMarketQuery_Query;

export type GetIsLikedByAddressIdForCurrentUserQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_isLikedByAddressIdForCurrentUser_IsLikedByAddressIdForCurrentUserResponse = {
  __typename: 'IsLikedByAddressIdForCurrentUserResponse',
  isLiked: boolean
};

export type GetIsLikedByAddressIdForCurrentUserQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query = {
  __typename: 'OdProtosBuyerServicesBuyer_Buyer_Query',
  isLikedByAddressIdForCurrentUser: GetIsLikedByAddressIdForCurrentUserQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_isLikedByAddressIdForCurrentUser_IsLikedByAddressIdForCurrentUserResponse | null
};

export type GetIsLikedByAddressIdForCurrentUserQuery_Query = {
  buyer: GetIsLikedByAddressIdForCurrentUserQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query
};


export type GetIsLikedByAddressIdForCurrentUserQueryVariables = Exact<{
  addressId: string;
}>;


export type GetIsLikedByAddressIdForCurrentUserQuery = GetIsLikedByAddressIdForCurrentUserQuery_Query;

export type GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl = {
  __typename: 'PhotoUrl',
  fullSize: string
};

export type GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property_photos_PhotoConnection_nodes_PropertyPhoto = {
  __typename: 'PropertyPhoto',
  urls: GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property_photos_PhotoConnection_nodes_PropertyPhoto_urls_PhotoUrl | null
};

export type GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property_photos_PhotoConnection = {
  __typename: 'PhotoConnection',
  nodes: Array<GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property_photos_PhotoConnection_nodes_PropertyPhoto> | null
};

export type GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property = {
  __typename: 'Property',
  addressId: string,
  listTimestamp: string | null,
  photos: GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property_photos_PhotoConnection | null
};

export type GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery = {
  __typename: 'PropertyQuery',
  properties: Array<GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery_properties_Property | null> | null
};

export type GetPropertyPhotosByAddressIDsQuery_Query = {
  property: GetPropertyPhotosByAddressIDsQuery_property_PropertyQuery
};


export type GetPropertyPhotosByAddressIDsQueryVariables = Exact<{
  addressIds: Array<string> | string;
  photoCount: number;
}>;


export type GetPropertyPhotosByAddressIDsQuery = GetPropertyPhotosByAddressIDsQuery_Query;

export type GetVariantRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariant_OdProtosVariantServices_GetVariantResponse_variant_OdProtosVariantData_Variant = {
  __typename: 'OdProtosVariantData_Variant',
  value: string
};

export type GetVariantRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariant_OdProtosVariantServices_GetVariantResponse = {
  __typename: 'OdProtosVariantServices_GetVariantResponse',
  variant: GetVariantRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariant_OdProtosVariantServices_GetVariantResponse_variant_OdProtosVariantData_Variant | null
};

export type GetVariantRequestQuery_variant_OdProtosVariantServices_Variant_Query = {
  __typename: 'OdProtosVariantServices_Variant_Query',
  getVariant: GetVariantRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariant_OdProtosVariantServices_GetVariantResponse | null
};

export type GetVariantRequestQuery_Query = {
  variant: GetVariantRequestQuery_variant_OdProtosVariantServices_Variant_Query
};


export type GetVariantRequestQueryVariables = Exact<{
  grain?: OdProtosVariantData_GrainInput | null | undefined;
  key: string;
  props?: GoogleProtobuf_StructInput | null | undefined;
  autoImpression?: boolean | null | undefined;
}>;


export type GetVariantRequestQuery = GetVariantRequestQuery_Query;

export type GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariants_OdProtosVariantServices_GetVariantsResponse_variants_OdProtosVariantServices_GetVariantsResponse_VariantsEntry_value_OdProtosVariantData_Variant = {
  __typename: 'OdProtosVariantData_Variant',
  value: string
};

export type GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariants_OdProtosVariantServices_GetVariantsResponse_variants_OdProtosVariantServices_GetVariantsResponse_VariantsEntry = {
  __typename: 'OdProtosVariantServices_GetVariantsResponse_VariantsEntry',
  key: string,
  value: GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariants_OdProtosVariantServices_GetVariantsResponse_variants_OdProtosVariantServices_GetVariantsResponse_VariantsEntry_value_OdProtosVariantData_Variant | null
};

export type GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariants_OdProtosVariantServices_GetVariantsResponse = {
  __typename: 'OdProtosVariantServices_GetVariantsResponse',
  variants: Array<GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariants_OdProtosVariantServices_GetVariantsResponse_variants_OdProtosVariantServices_GetVariantsResponse_VariantsEntry>
};

export type GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query = {
  __typename: 'OdProtosVariantServices_Variant_Query',
  getVariants: GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getVariants_OdProtosVariantServices_GetVariantsResponse | null
};

export type GetSeveralVariantsRequestQuery_Query = {
  variant: GetSeveralVariantsRequestQuery_variant_OdProtosVariantServices_Variant_Query
};


export type GetSeveralVariantsRequestQueryVariables = Exact<{
  grain?: OdProtosVariantData_GrainInput | null | undefined;
  keys?: Array<string> | string | null | undefined;
  props?: GoogleProtobuf_StructInput | null | undefined;
}>;


export type GetSeveralVariantsRequestQuery = GetSeveralVariantsRequestQuery_Query;

export type GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getFeatureFlags_OdProtosVariantServices_GetFeatureFlagsResponse_variants_OdProtosVariantServices_GetFeatureFlagsResponse_VariantsEntry_value_OdProtosVariantData_Variant = {
  __typename: 'OdProtosVariantData_Variant',
  value: string
};

export type GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getFeatureFlags_OdProtosVariantServices_GetFeatureFlagsResponse_variants_OdProtosVariantServices_GetFeatureFlagsResponse_VariantsEntry = {
  __typename: 'OdProtosVariantServices_GetFeatureFlagsResponse_VariantsEntry',
  key: string,
  value: GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getFeatureFlags_OdProtosVariantServices_GetFeatureFlagsResponse_variants_OdProtosVariantServices_GetFeatureFlagsResponse_VariantsEntry_value_OdProtosVariantData_Variant | null
};

export type GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getFeatureFlags_OdProtosVariantServices_GetFeatureFlagsResponse = {
  __typename: 'OdProtosVariantServices_GetFeatureFlagsResponse',
  variants: Array<GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getFeatureFlags_OdProtosVariantServices_GetFeatureFlagsResponse_variants_OdProtosVariantServices_GetFeatureFlagsResponse_VariantsEntry>
};

export type GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query = {
  __typename: 'OdProtosVariantServices_Variant_Query',
  getFeatureFlags: GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query_getFeatureFlags_OdProtosVariantServices_GetFeatureFlagsResponse | null
};

export type GetSeveralFeatureFlagsRequestQuery_Query = {
  variant: GetSeveralFeatureFlagsRequestQuery_variant_OdProtosVariantServices_Variant_Query
};


export type GetSeveralFeatureFlagsRequestQueryVariables = Exact<{
  grain?: OdProtosVariantData_GrainInput | null | undefined;
  keys?: Array<string> | string | null | undefined;
  props?: GoogleProtobuf_StructInput | null | undefined;
}>;


export type GetSeveralFeatureFlagsRequestQuery = GetSeveralFeatureFlagsRequestQuery_Query;

export type ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse_leads_OdProtosWebData_Lead_latestOffer_OdProtosWebData_Offer = {
  __typename: 'OdProtosWebData_Offer',
  state: OdProtosWebData_Offer_State
};

export type ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse_leads_OdProtosWebData_Lead_address_OdProtosCasaData_Address = {
  __typename: 'OdProtosCasaData_Address',
  uuid: string,
  street: string
};

export type ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse_leads_OdProtosWebData_Lead = {
  __typename: 'OdProtosWebData_Lead',
  id: string,
  isQualified: boolean,
  latestOffer: ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse_leads_OdProtosWebData_Lead_latestOffer_OdProtosWebData_Offer | null,
  address: ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse_leads_OdProtosWebData_Lead_address_OdProtosCasaData_Address | null
};

export type ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse = {
  __typename: 'OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse',
  leads: Array<ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse_leads_OdProtosWebData_Lead>
};

export type ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query = {
  __typename: 'OdProtosWebServicesSellDirect_SellDirect_Query',
  listLeadsOnUniqueAddresses: ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query_listLeadsOnUniqueAddresses_OdProtosWebServicesSellDirect_ListLeadsOnUniqueAddressesResponse | null
};

export type ListLeadsOnUniqueAddressesQuery_Query = {
  sellDirect: ListLeadsOnUniqueAddressesQuery_sellDirect_OdProtosWebServicesSellDirect_SellDirect_Query
};


export type ListLeadsOnUniqueAddressesQueryVariables = Exact<{
  customerUuid: string;
}>;


export type ListLeadsOnUniqueAddressesQuery = ListLeadsOnUniqueAddressesQuery_Query;

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress = {
  __typename: 'OdProtosCommon_EmailAddress',
  value: string
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email = {
  __typename: 'OdProtosCustomerV1Data_Email',
  address: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress | null
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress = {
  __typename: 'OdProtosCommon_EmailAddress',
  value: string
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email = {
  __typename: 'OdProtosCustomerV1Data_Email',
  address: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email_address_OdProtosCommon_EmailAddress | null
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber = {
  __typename: 'OdProtosCommon_PhoneNumber',
  value: string
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone = {
  __typename: 'OdProtosCustomerV1Data_Phone',
  type: OdProtosCustomerV1Data_Phone_PhoneType,
  number: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber | null
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber = {
  __typename: 'OdProtosCommon_PhoneNumber',
  value: string
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone = {
  __typename: 'OdProtosCustomerV1Data_Phone',
  type: OdProtosCustomerV1Data_Phone_PhoneType,
  number: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone_number_OdProtosCommon_PhoneNumber | null
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer = {
  __typename: 'OdProtosCustomerV1Data_Customer',
  uuid: string,
  createdAt: string | null,
  firstName: string,
  lastName: string,
  isAgent: boolean,
  ccpaSaleOfDataOptOut: boolean,
  fullName: string | null,
  primaryEmail: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryEmail_OdProtosCustomerV1Data_Email | null,
  otherEmails: Array<GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherEmails_OdProtosCustomerV1Data_Email>,
  primaryPhoneNumber: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_primaryPhoneNumber_OdProtosCustomerV1Data_Phone | null,
  otherPhoneNumbers: Array<GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer_otherPhoneNumbers_OdProtosCustomerV1Data_Phone>
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer = {
  __typename: 'OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer',
  customer: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer_customer_OdProtosCustomerV1Data_Customer | null
};

export type GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query = {
  __typename: 'OdProtosCustomerV1Services_Customer_Query',
  getCurrentCustomer: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query_getCurrentCustomer_OdProtosCustomerV1Services_CustomerResponses_GetCurrentCustomer | null
};

export type GetCurrentCustomerQuery_Query = {
  customerService: GetCurrentCustomerQuery_customerService_OdProtosCustomerV1Services_Customer_Query
};


export type GetCurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentCustomerQuery = GetCurrentCustomerQuery_Query;

export type GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentsByCustomer_WebViewingAppointment = {
  __typename: 'WebViewingAppointment',
  listing_address_id: string | null,
  scheduled_for: string | null,
  end_time: string | null,
  timezone: string | null
};

export type GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentAvailabilityForListing_WebViewingAppointmentAvailability_available_days_WebAvailableDay_available_slots_WebAvailableSlot = {
  __typename: 'WebAvailableSlot',
  start_time: string,
  end_time: string,
  is_now: boolean
};

export type GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentAvailabilityForListing_WebViewingAppointmentAvailability_available_days_WebAvailableDay = {
  __typename: 'WebAvailableDay',
  date: string,
  available_slots: Array<GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentAvailabilityForListing_WebViewingAppointmentAvailability_available_days_WebAvailableDay_available_slots_WebAvailableSlot | null> | null
};

export type GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentAvailabilityForListing_WebViewingAppointmentAvailability = {
  __typename: 'WebViewingAppointmentAvailability',
  timezone: string | null,
  available_days: Array<GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentAvailabilityForListing_WebViewingAppointmentAvailability_available_days_WebAvailableDay> | null
};

export type GetViewingAppointmentsDataQuery_web_WebQuery = {
  __typename: 'WebQuery',
  viewingAppointmentsByCustomer: Array<GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentsByCustomer_WebViewingAppointment | null> | null,
  viewingAppointmentAvailabilityForListing: GetViewingAppointmentsDataQuery_web_WebQuery_viewingAppointmentAvailabilityForListing_WebViewingAppointmentAvailability | null
};

export type GetViewingAppointmentsDataQuery_Query = {
  web: GetViewingAppointmentsDataQuery_web_WebQuery
};


export type GetViewingAppointmentsDataQueryVariables = Exact<{
  customerUuid: string;
  listingId: string;
  daysOut?: number | null | undefined;
  durationMinutes?: number | null | undefined;
}>;


export type GetViewingAppointmentsDataQuery = GetViewingAppointmentsDataQuery_Query;

export type GetViewingAppointmentsByCustomerQuery_web_WebQuery_viewingAppointmentsByCustomer_WebViewingAppointment = {
  __typename: 'WebViewingAppointment',
  listing_address_id: string | null,
  scheduled_for: string | null,
  end_time: string | null,
  timezone: string | null
};

export type GetViewingAppointmentsByCustomerQuery_web_WebQuery = {
  __typename: 'WebQuery',
  viewingAppointmentsByCustomer: Array<GetViewingAppointmentsByCustomerQuery_web_WebQuery_viewingAppointmentsByCustomer_WebViewingAppointment | null> | null
};

export type GetViewingAppointmentsByCustomerQuery_Query = {
  web: GetViewingAppointmentsByCustomerQuery_web_WebQuery
};


export type GetViewingAppointmentsByCustomerQueryVariables = Exact<{
  customerUuid: string;
}>;


export type GetViewingAppointmentsByCustomerQuery = GetViewingAppointmentsByCustomerQuery_Query;

export type SearchZonesByLocationQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_searchZonesByLocation_OdProtosGeoDataStoreServices_SearchZonesByLocationResponse_zones_OdProtosGeoDataStoreData_Zone = {
  __typename: 'OdProtosGeoDataStoreData_Zone',
  zoneType: OdProtosGeoDataStoreData_Zone_Type,
  uuid: string,
  name: string,
  slug: string
};

export type SearchZonesByLocationQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_searchZonesByLocation_OdProtosGeoDataStoreServices_SearchZonesByLocationResponse = {
  __typename: 'OdProtosGeoDataStoreServices_SearchZonesByLocationResponse',
  zones: Array<SearchZonesByLocationQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_searchZonesByLocation_OdProtosGeoDataStoreServices_SearchZonesByLocationResponse_zones_OdProtosGeoDataStoreData_Zone>
};

export type SearchZonesByLocationQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query = {
  __typename: 'OdProtosGeoDataStoreServices_GeoDataStore_Query',
  searchZonesByLocation: SearchZonesByLocationQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query_searchZonesByLocation_OdProtosGeoDataStoreServices_SearchZonesByLocationResponse | null
};

export type SearchZonesByLocationQuery_Query = {
  geoDataStore: SearchZonesByLocationQuery_geoDataStore_OdProtosGeoDataStoreServices_GeoDataStore_Query
};


export type SearchZonesByLocationQueryVariables = Exact<{
  latitude: number;
  longitude: number;
  searchDistance: number;
}>;


export type SearchZonesByLocationQuery = SearchZonesByLocationQuery_Query;

export type HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getHistoricalMarketMetrics_OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse_unfilteredGraphs_OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs = {
  __typename: 'OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs',
  medianSalePriceGraph: Array<number>,
  daysOnMarketGraph: Array<number>,
  homesSoldGraph: Array<number>
};

export type HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getHistoricalMarketMetrics_OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse_filteredGraphs_OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs = {
  __typename: 'OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs',
  medianSalePriceGraph: Array<number>,
  daysOnMarketGraph: Array<number>,
  homesSoldGraph: Array<number>
};

export type HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getHistoricalMarketMetrics_OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse = {
  __typename: 'OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse',
  medianSalePrice: number,
  medianSalePriceMom: number,
  daysOnMarket: number,
  daysOnMarketMom: number,
  homesSold: number,
  homesSoldMom: number,
  homesOnMarket: number,
  homesOnMarketMom: number,
  avgListingPrice: number,
  avgListingPriceMom: number,
  unfilteredGraphs: HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getHistoricalMarketMetrics_OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse_unfilteredGraphs_OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs | null,
  filteredGraphs: HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getHistoricalMarketMetrics_OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse_filteredGraphs_OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsGraphs | null
};

export type HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query = {
  __typename: 'OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query',
  getHistoricalMarketMetrics: HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getHistoricalMarketMetrics_OdProtosSellerDashboardMetricsServices_GetHistoricalMarketMetricsResponse | null
};

export type HistoricalMarketMetricsQueryQuery_Query = {
  sellerDashboardMetrics: HistoricalMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query
};


export type HistoricalMarketMetricsQueryQueryVariables = Exact<{
  zip?: string | null | undefined;
  filters?: OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput | null | undefined;
  numWeeks?: number | null | undefined;
}>;


export type HistoricalMarketMetricsQueryQuery = HistoricalMarketMetricsQueryQuery_Query;

export type GetMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getMarketMetrics_OdProtosSellerDashboardMetricsServices_GetMarketMetricsResponse = {
  __typename: 'OdProtosSellerDashboardMetricsServices_GetMarketMetricsResponse',
  marketIdentifier: string,
  timePeriod: string | null,
  homesSold: number,
  homesSoldWow: number,
  newListings: number,
  newListingsWow: number,
  delistings: number,
  delistingsWow: number,
  homesOnMarket: number,
  homesOnMarketWow: number,
  averagePriceChange: number,
  averagePriceChangeWow: number,
  marketHotness: number
};

export type GetMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query = {
  __typename: 'OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query',
  getMarketMetrics: GetMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query_getMarketMetrics_OdProtosSellerDashboardMetricsServices_GetMarketMetricsResponse | null
};

export type GetMarketMetricsQueryQuery_Query = {
  sellerDashboardMetrics: GetMarketMetricsQueryQuery_sellerDashboardMetrics_OdProtosSellerDashboardMetricsServices_SellerDashboardMetrics_Query
};


export type GetMarketMetricsQueryQueryVariables = Exact<{
  marketIdentifier?: string | null | undefined;
}>;


export type GetMarketMetricsQueryQuery = GetMarketMetricsQueryQuery_Query;

export type PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction_agent_BwODAgent = {
  __typename: 'BwODAgent',
  id: string | null,
  email: string | null,
  name: string | null,
  photoUrl: string | null,
  primaryNumber: string | null,
  isPartnerAgent: boolean | null
};

export type PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction_propertyV2_MarketplaceProperty = {
  __typename: 'MarketplaceProperty',
  addressToken: string,
  photos: Array<string> | null
};

export type PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction_tasks_BuyClosingTask = {
  __typename: 'BuyClosingTask',
  id: string | null,
  description: string | null,
  title: string | null,
  taskType: BuyClosingTaskType | null,
  isDone: boolean | null
};

export type PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction = {
  __typename: 'PurchaseTransaction',
  id: string | null,
  acceptedOfferPrice: number | null,
  buyerCustomerId: string | null,
  buyerEmail: string | null,
  buyerName: string | null,
  buyerPhone: string | null,
  inspectionPeriodDaysRemaining: number | null,
  listingOfferId: string | null,
  transactionState: TransactionState | null,
  resaleCloseOfEscrowDaysRemaining: number | null,
  agent: PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction_agent_BwODAgent | null,
  propertyV2: PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction_propertyV2_MarketplaceProperty | null,
  tasks: Array<PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction_tasks_BuyClosingTask> | null
};

export type PurchaseTransactionQuery_buy_BuyQuery = {
  __typename: 'BuyQuery',
  purchaseTransaction: PurchaseTransactionQuery_buy_BuyQuery_purchaseTransaction_PurchaseTransaction
};

export type PurchaseTransactionQuery_Query = {
  buy: PurchaseTransactionQuery_buy_BuyQuery
};


export type PurchaseTransactionQueryVariables = Exact<{
  transactionId: string;
}>;


export type PurchaseTransactionQuery = PurchaseTransactionQuery_Query;

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address = {
  __typename: 'OdProtosCasaData_Address',
  street: string,
  uuid: string
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput = {
  __typename: 'OdProtosSellReceptionData_SellerInput',
  uuid: string
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_sellDirectOffer_OdProtosWebDataSellDirect_Offer = {
  __typename: 'OdProtosWebDataSellDirect_Offer',
  isClosed: boolean
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction = {
  __typename: 'DeniedTransaction',
  id: string,
  address: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction = {
  __typename: 'InContractTransaction',
  id: string,
  sellDirectOffer: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_sellDirectOffer_OdProtosWebDataSellDirect_Offer,
  address: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InitializingTransaction = {
  __typename: 'InitializingTransaction',
  id: string,
  address: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction = {
  __typename: 'QualifiedTransaction',
  id: string,
  address: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_WithdrawnTransaction = {
  __typename: 'WithdrawnTransaction',
  id: string,
  address: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions =
  | NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction
  | NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction
  | NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InitializingTransaction
  | NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction
  | NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_WithdrawnTransaction
;

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery = {
  __typename: 'SellingQuery',
  transactions: Array<NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions>
};

export type NavTransactionsQuery_customerAccount_CustomerAccountQuery = {
  __typename: 'CustomerAccountQuery',
  selling: NavTransactionsQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery
};

export type NavTransactionsQuery_Query = {
  customerAccount: NavTransactionsQuery_customerAccount_CustomerAccountQuery
};


export type NavTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type NavTransactionsQuery = NavTransactionsQuery_Query;

export type HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_favorites_MarketplacePropertyListResult = {
  __typename: 'MarketplacePropertyListResult',
  id: string,
  addressToken: string | null,
  badges: Array<Badge> | null,
  beds: number | null,
  baths: number | null,
  city: string | null,
  dwellingType: DwellingType | null,
  fullAddress: string | null,
  isLiked: boolean | null,
  listDate: string | null,
  listPrice: number | null,
  livingSquareFootage: number | null,
  listingState: ListingState | null,
  neighborhood: string | null,
  photos: Array<string> | null,
  slug: string | null,
  state: string | null,
  street: string | null,
  zip: string | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_tours_BuyingTour_property_MarketplacePropertyListResult = {
  __typename: 'MarketplacePropertyListResult',
  id: string,
  addressToken: string | null,
  badges: Array<Badge> | null,
  beds: number | null,
  baths: number | null,
  city: string | null,
  dwellingType: DwellingType | null,
  fullAddress: string | null,
  isLiked: boolean | null,
  listDate: string | null,
  listPrice: number | null,
  livingSquareFootage: number | null,
  listingState: ListingState | null,
  neighborhood: string | null,
  photos: Array<string> | null,
  slug: string | null,
  state: string | null,
  street: string | null,
  zip: string | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_tours_BuyingTour = {
  __typename: 'BuyingTour',
  id: string,
  scheduledFor: string | null,
  endTime: string | null,
  timezone: string | null,
  listingId: string | null,
  listingAddressToken: string,
  listingReadableAddress: string,
  property: HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_tours_BuyingTour_property_MarketplacePropertyListResult | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_tourFeedbacks_OdProtosBuyerV2Data_TourFeedback = {
  __typename: 'OdProtosBuyerV2Data_TourFeedback',
  tourFeedbackUuid: string,
  viewingAppointmentId: string,
  sentiment: OdProtosBuyerV2Data_TourFeedbackSentiment
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery = {
  __typename: 'BuyingQuery',
  favorites: Array<HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_favorites_MarketplacePropertyListResult>,
  tours: Array<HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_tours_BuyingTour>,
  tourFeedbacks: Array<HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery_tourFeedbacks_OdProtosBuyerV2Data_TourFeedback>
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address = {
  __typename: 'OdProtosCasaData_Address',
  uuid: string,
  street: string,
  unitNumber: string,
  city: string,
  state: string,
  postalCode: string,
  latitude: number,
  longitude: number
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput_homeDetails_OdProtosSellReceptionData_SellerInput_HomeDetails_physicalDetails_OdProtosSellReceptionData_SellerInput_HomeDetails_PhysicalDetails = {
  __typename: 'OdProtosSellReceptionData_SellerInput_HomeDetails_PhysicalDetails',
  bedrooms: number | null,
  bathrooms: number | null,
  bathroomsFull: number | null,
  bathroomsHalf: number | null,
  sqFt: number | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput_homeDetails_OdProtosSellReceptionData_SellerInput_HomeDetails = {
  __typename: 'OdProtosSellReceptionData_SellerInput_HomeDetails',
  physicalDetails: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput_homeDetails_OdProtosSellReceptionData_SellerInput_HomeDetails_physicalDetails_OdProtosSellReceptionData_SellerInput_HomeDetails_PhysicalDetails | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput = {
  __typename: 'OdProtosSellReceptionData_SellerInput',
  uuid: string,
  homeDetails: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput_homeDetails_OdProtosSellReceptionData_SellerInput_HomeDetails | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_sellDirectOffer_OdProtosWebDataSellDirect_Offer = {
  __typename: 'OdProtosWebDataSellDirect_Offer',
  isClosed: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_inspection_InspectionTask = {
  __typename: 'InspectionTask',
  complete: boolean,
  state: InspectionState
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_serviceProviders_ServiceProvidersTask = {
  __typename: 'ServiceProvidersTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_disclosures_DisclosuresTask = {
  __typename: 'DisclosuresTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_finalWalkthrough_FinalWalkthroughTask = {
  __typename: 'FinalWalkthroughTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_lateCheckoutAddendum_DocumentSigningTask = {
  __typename: 'DocumentSigningTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_changeCloseOfEscrowAddendum_DocumentSigningTask = {
  __typename: 'DocumentSigningTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_formAddendums_DocumentSigningTask = {
  __typename: 'DocumentSigningTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks = {
  __typename: 'RequiredClosingTasks',
  inspection: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_inspection_InspectionTask | null,
  serviceProviders: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_serviceProviders_ServiceProvidersTask | null,
  disclosures: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_disclosures_DisclosuresTask | null,
  finalWalkthrough: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_finalWalkthrough_FinalWalkthroughTask,
  lateCheckoutAddendum: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_lateCheckoutAddendum_DocumentSigningTask | null,
  changeCloseOfEscrowAddendum: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_changeCloseOfEscrowAddendum_DocumentSigningTask | null,
  formAddendums: Array<HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks_formAddendums_DocumentSigningTask>
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_RepricingStep_contractSetup_ContractSetup = {
  __typename: 'ContractSetup',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_RepricingStep_purchaseAgreement_DocumentSigningTask = {
  __typename: 'DocumentSigningTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep = {
  __typename: 'ClosingStep',
  id: string,
  requiredTasks: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep_requiredTasks_RequiredClosingTasks
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_RepricingStep = {
  __typename: 'RepricingStep',
  id: string,
  contractSetup: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_RepricingStep_contractSetup_ContractSetup | null,
  purchaseAgreement: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_RepricingStep_purchaseAgreement_DocumentSigningTask | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep =
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_ClosingStep
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep_RepricingStep
;

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_appAssessment_AppAssessment = {
  __typename: 'AppAssessment',
  completedAt: string | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_inPersonAssessment_InPersonAssessment = {
  __typename: 'InPersonAssessment',
  isScheduled: boolean,
  hasAvailableSlots: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_expertHandoffAssessment_ExpertHandoffAssessment = {
  __typename: 'ExpertHandoffAssessment',
  isScheduled: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_selfServeVirtualAssessment_SelfServeVirtualAssessmentInfo_data_OdProtosWebData_VirtualAssessment = {
  __typename: 'OdProtosWebData_VirtualAssessment',
  ssvaCompletedAt: string | null,
  ssvaRecordingsSubmitted: boolean,
  ssvaQuestionnaireSubmitted: boolean,
  ssvaInteriorRecordingsSubmitted: boolean,
  ssvaBackyardRecordingsSubmitted: boolean,
  ssvaFrontyardRecordingsSubmitted: boolean,
  ssvaWholeHomeRecordingsSubmitted: boolean,
  ssvaSellerDisclosureDocumentRecordingsSubmitted: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_selfServeVirtualAssessment_SelfServeVirtualAssessmentInfo = {
  __typename: 'SelfServeVirtualAssessmentInfo',
  data: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_selfServeVirtualAssessment_SelfServeVirtualAssessmentInfo_data_OdProtosWebData_VirtualAssessment | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ContractSigningStep_contractSetup_ContractSetup = {
  __typename: 'ContractSetup',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ContractSigningStep_purchaseAgreement_DocumentSigningTask = {
  __typename: 'DocumentSigningTask',
  complete: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AgentAttributionDecisionStep = {
  __typename: 'AgentAttributionDecisionStep',
  id: string,
  referralInvitationPaymentEligibility: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep = {
  __typename: 'AssessmentStep',
  id: string,
  appAssessment: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_appAssessment_AppAssessment | null,
  inPersonAssessment: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_inPersonAssessment_InPersonAssessment | null,
  expertHandoffAssessment: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_expertHandoffAssessment_ExpertHandoffAssessment | null,
  selfServeVirtualAssessment: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep_selfServeVirtualAssessment_SelfServeVirtualAssessmentInfo | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ContractSigningStep = {
  __typename: 'ContractSigningStep',
  id: string,
  contractSetup: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ContractSigningStep_contractSetup_ContractSetup | null,
  purchaseAgreement: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ContractSigningStep_purchaseAgreement_DocumentSigningTask | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_HoldingOfferStep = {
  __typename: 'HoldingOfferStep',
  id: string
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ReferralInvitationDecisionStep = {
  __typename: 'ReferralInvitationDecisionStep',
  id: string,
  referralInvitationPaymentEligibility: boolean
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_UnderwritingStep = {
  __typename: 'UnderwritingStep',
  id: string
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep =
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AgentAttributionDecisionStep
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_AssessmentStep
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ContractSigningStep
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_HoldingOfferStep
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_ReferralInvitationDecisionStep
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep_UnderwritingStep
;

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction = {
  __typename: 'DeniedTransaction',
  id: string,
  address: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction = {
  __typename: 'InContractTransaction',
  id: string,
  sellDirectOffer: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_sellDirectOffer_OdProtosWebDataSellDirect_Offer,
  currentStep: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction_currentStep | null,
  address: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InitializingTransaction = {
  __typename: 'InitializingTransaction',
  id: string,
  address: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction = {
  __typename: 'QualifiedTransaction',
  id: string,
  currentStep: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction_currentStep | null,
  address: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_WithdrawnTransaction = {
  __typename: 'WithdrawnTransaction',
  id: string,
  address: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_address_OdProtosCasaData_Address,
  sellerInput: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction_sellerInput_OdProtosSellReceptionData_SellerInput | null
};

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions =
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_DeniedTransaction
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InContractTransaction
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_InitializingTransaction
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_QualifiedTransaction
  | HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions_WithdrawnTransaction
;

export type HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery = {
  __typename: 'SellingQuery',
  transactions: Array<HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery_transactions>
};

export type HubDataQuery_customerAccount_CustomerAccountQuery = {
  __typename: 'CustomerAccountQuery',
  buying: HubDataQuery_customerAccount_CustomerAccountQuery_buying_BuyingQuery,
  selling: HubDataQuery_customerAccount_CustomerAccountQuery_selling_SellingQuery
};

export type HubDataQuery_Query = {
  customerAccount: HubDataQuery_customerAccount_CustomerAccountQuery
};


export type HubDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HubDataQuery = HubDataQuery_Query;

export type GetBuyDirectPropertyInfoQuery_marketplace_MarketplaceQuery_property_MarketplaceProperty = {
  __typename: 'MarketplaceProperty',
  addressToken: string,
  bathrooms: number | null,
  bedrooms: number | null,
  buyDirectPrice: number | null,
  city: string,
  fhaEligible: boolean | null,
  fhaEligibleDate: string | null,
  listPrice: number | null,
  listingState: ListingState | null,
  listingTags: Array<ListingTag> | null,
  photos: Array<string> | null,
  sellerDisclosuresDownloadUrl: string | null,
  slug: string,
  sqFtTotalLiving: number | null,
  state: string | null,
  street: string | null,
  unitNumber: string | null,
  unitType: string | null,
  zip: string | null
};

export type GetBuyDirectPropertyInfoQuery_marketplace_MarketplaceQuery = {
  __typename: 'MarketplaceQuery',
  property: GetBuyDirectPropertyInfoQuery_marketplace_MarketplaceQuery_property_MarketplaceProperty | null
};

export type GetBuyDirectPropertyInfoQuery_Query = {
  marketplace: GetBuyDirectPropertyInfoQuery_marketplace_MarketplaceQuery
};


export type GetBuyDirectPropertyInfoQueryVariables = Exact<{
  addressToken: string;
}>;


export type GetBuyDirectPropertyInfoQuery = GetBuyDirectPropertyInfoQuery_Query;

export type GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers_offers_OdProtosWebData_ListingOffer_address_OdProtosCasaData_Address = {
  __typename: 'OdProtosCasaData_Address',
  uuid: string
};

export type GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers_offers_OdProtosWebData_ListingOffer_details_OdProtosWebData_ListingOfferDetails = {
  __typename: 'OdProtosWebData_ListingOfferDetails',
  contractSignatureId: string,
  state: string
};

export type GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers_offers_OdProtosWebData_ListingOffer = {
  __typename: 'OdProtosWebData_ListingOffer',
  id: number,
  uuid: string,
  address: GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers_offers_OdProtosWebData_ListingOffer_address_OdProtosCasaData_Address | null,
  details: GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers_offers_OdProtosWebData_ListingOffer_details_OdProtosWebData_ListingOfferDetails | null
};

export type GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers = {
  __typename: 'OdProtosWebServicesListingOffer_Responses_ListOffers',
  offers: Array<GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers_offers_OdProtosWebData_ListingOffer>
};

export type GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query = {
  __typename: 'OdProtosWebServicesListingOffer_ListingOffer_Query',
  listOffers: GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query_listOffers_OdProtosWebServicesListingOffer_Responses_ListOffers | null
};

export type GetResaleOffersQuery_Query = {
  webListingOffer: GetResaleOffersQuery_webListingOffer_OdProtosWebServicesListingOffer_ListingOffer_Query
};


export type GetResaleOffersQueryVariables = Exact<{
  customerId: string;
}>;


export type GetResaleOffersQuery = GetResaleOffersQuery_Query;

export type GetBuyDirectS3UrlsQuery_seller_OdProtosSellSellerServices_Seller_Query = {
  __typename: 'OdProtosSellSellerServices_Seller_Query',
  s3DocumentUploadUrl: string | null,
  s3DocumentDownloadUrl: string | null
};

export type GetBuyDirectS3UrlsQuery_Query = {
  seller: GetBuyDirectS3UrlsQuery_seller_OdProtosSellSellerServices_Seller_Query
};


export type GetBuyDirectS3UrlsQueryVariables = Exact<{
  bucketName: string;
  documentName: string;
}>;


export type GetBuyDirectS3UrlsQuery = GetBuyDirectS3UrlsQuery_Query;

export type NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_naturalLanguagePropertySearch_NaturalSearchResult_properties_NaturalSearchProperty_property_MarketplaceProperty = {
  __typename: 'MarketplaceProperty',
  addressToken: string,
  slug: string,
  street: string | null,
  city: string,
  state: string | null,
  listPrice: number | null,
  bedrooms: number | null,
  bathrooms: number | null,
  sqFtTotalLiving: number | null,
  dwellingType: DwellingType | null,
  isLiked: boolean | null,
  photos: Array<string> | null
};

export type NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_naturalLanguagePropertySearch_NaturalSearchResult_properties_NaturalSearchProperty = {
  __typename: 'NaturalSearchProperty',
  matchedPhotoUrl: string | null,
  property: NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_naturalLanguagePropertySearch_NaturalSearchResult_properties_NaturalSearchProperty_property_MarketplaceProperty
};

export type NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_naturalLanguagePropertySearch_NaturalSearchResult = {
  __typename: 'NaturalSearchResult',
  summary: string | null,
  emptyReason: NaturalSearchEmptyReason | null,
  properties: Array<NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_naturalLanguagePropertySearch_NaturalSearchResult_properties_NaturalSearchProperty>
};

export type NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query = {
  __typename: 'OdProtosBuyerServicesBuyer_Buyer_Query',
  naturalLanguagePropertySearch: NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query_naturalLanguagePropertySearch_NaturalSearchResult | null
};

export type NaturalLanguagePropertySearchQuery_Query = {
  buyer: NaturalLanguagePropertySearchQuery_buyer_OdProtosBuyerServicesBuyer_Buyer_Query
};


export type NaturalLanguagePropertySearchQueryVariables = Exact<{
  query: string;
  limit?: number | null | undefined;
  market?: string | null | undefined;
}>;


export type NaturalLanguagePropertySearchQuery = NaturalLanguagePropertySearchQuery_Query;

export const SimilarPropertyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimilarProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"baths"}},{"kind":"Field","name":{"kind":"Name","value":"beds"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"livingSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}}]}}]} as unknown as DocumentNode<SimilarPropertyFragment, unknown>;
export const SimilarPropertiesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimilarProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListQueryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimilarProperty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimilarProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"baths"}},{"kind":"Field","name":{"kind":"Name","value":"beds"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"livingSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}}]}}]} as unknown as DocumentNode<SimilarPropertiesFragment, unknown>;
export const PropertyDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceProperty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"buyDirectPrice"}},{"kind":"Field","name":{"kind":"Name","value":"canSelfTour"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeDaysOnMarket"}},{"kind":"Field","name":{"kind":"Name","value":"daysOnMarket"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayBadge"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedMonthlyPayment"}},{"kind":"Field","name":{"kind":"Name","value":"exteriorStories"}},{"kind":"Field","name":{"kind":"Name","value":"fhaEligible"}},{"kind":"Field","name":{"kind":"Name","value":"fhaEligibleDate"}},{"kind":"Field","name":{"kind":"Name","value":"garageSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"hasPrivatePool"}},{"kind":"Field","name":{"kind":"Name","value":"hasCommunityPool"}},{"kind":"Field","name":{"kind":"Name","value":"hoas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"feeFrequency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inGatedCommunity"}},{"kind":"Field","name":{"kind":"Name","value":"kitchenCountertop"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listingHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"mls"}},{"kind":"Field","name":{"kind":"Name","value":"originalListPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"soldPriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"currentListPriceCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyDirectDiscountPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"estimatedBuyDirectMonthlyPayment"}},{"kind":"Field","name":{"kind":"Name","value":"listingState"}},{"kind":"Field","name":{"kind":"Name","value":"listingTags"}},{"kind":"Field","name":{"kind":"Name","value":"market"}},{"kind":"Field","name":{"kind":"Name","value":"masterBedroomLocation"}},{"kind":"Field","name":{"kind":"Name","value":"floorPlanPhotos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"photos"}},{"kind":"Field","name":{"kind":"Name","value":"photosLg"}},{"kind":"Field","name":{"kind":"Name","value":"photosXl"}},{"kind":"Field","name":{"kind":"Name","value":"pricePerSqFt"}},{"kind":"Field","name":{"kind":"Name","value":"shouldShowGuarantee"}},{"kind":"Field","name":{"kind":"Name","value":"schoolDistricts"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellerDisclosuresDownloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"similarProperties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimilarProperties"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtLot"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"subdivision"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimilarProperty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"baths"}},{"kind":"Field","name":{"kind":"Name","value":"beds"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"livingSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SimilarProperties"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListQueryResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimilarProperty"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}}]}}]} as unknown as DocumentNode<PropertyDetailsFragment, unknown>;
export const PropertiesByMarketResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertiesByMarketResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PropertySearchResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySlug"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"originalListPrice"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtLot"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resizable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PropertiesByMarketResultFragment, unknown>;
export const MarketplacePropertyListResultFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplacePropertyListResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"badges"}},{"kind":"Field","name":{"kind":"Name","value":"beds"}},{"kind":"Field","name":{"kind":"Name","value":"baths"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}},{"kind":"Field","name":{"kind":"Name","value":"listDate"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"livingSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"listingState"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]} as unknown as DocumentNode<MarketplacePropertyListResultFragment, unknown>;
export const UnsubscribeMailerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnsubscribeMailer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebServicesMarketing_UnsubscribeMailerRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unsubscribeMailer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}}]}}]}}]} as unknown as DocumentNode<UnsubscribeMailerMutation, UnsubscribeMailerMutationVariables>;
export const UpsertCommPreferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCommPreference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosCustomerV1Services_UpsertCommPreferenceRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerCommPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertCommPreference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commPreference"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertCommPreferenceMutation, UpsertCommPreferenceMutationVariables>;
export const SubmitTourFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitTourFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitTourFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tourFeedbackUuid"}},{"kind":"Field","name":{"kind":"Name","value":"viewingAppointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitTourFeedbackMutation, SubmitTourFeedbackMutationVariables>;
export const SetImpressionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetImpression"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosVariantData_GrainInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setImpression"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"grain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"variantValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantValue"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_empty"}}]}}]}}]}}]} as unknown as DocumentNode<SetImpressionMutation, SetImpressionMutationVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"params"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosCustomerV1Services_CustomerRequests_Update_ParamsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"params"},"value":{"kind":"Variable","name":{"kind":"Name","value":"params"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherEmails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAgent"}},{"kind":"Field","name":{"kind":"Name","value":"ccpaSaleOfDataOptOut"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const CreateViewingAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateViewingAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerUUID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createViewingAppointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerUUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerUUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"appointmentDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"appointmentTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentTime"}}},{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateViewingAppointmentMutation, CreateViewingAppointmentMutationVariables>;
export const UploadAgentPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadAgentPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"external"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aws"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3CreatePutObjectPresignedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"clientName"},"value":{"kind":"EnumValue","value":"IMGDROP_PRODUCTION"}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UploadAgentPhotoMutation, UploadAgentPhotoMutationVariables>;
export const CreateBuyDirectListingOfferDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateBuyDirectListingOffer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coBuyer"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_CustomerInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"downPaymentCents"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"financingType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebData_ListingOfferDetails_FinancingStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closeOfEscrow"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosCommon_DateInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preApprovalLetter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_DocumentInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listing"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneofInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addOns"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_AddOn"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tradeInAddress"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedHeroesHomeCredit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webBuyDirectListingOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBuyDirectOffer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"buyer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyer"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"coBuyer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coBuyer"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"downPaymentCents"},"value":{"kind":"Variable","name":{"kind":"Name","value":"downPaymentCents"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"financingType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"financingType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"closeOfEscrow"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closeOfEscrow"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preApprovalLetter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preApprovalLetter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"listing"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listing"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"addOns"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addOns"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"tradeInAddress"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tradeInAddress"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"requestedHeroesHomeCredit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedHeroesHomeCredit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingOfferId"}},{"kind":"Field","name":{"kind":"Name","value":"listingOfferUuid"}},{"kind":"Field","name":{"kind":"Name","value":"contractSignatureId"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBuyDirectListingOfferMutation, CreateBuyDirectListingOfferMutationVariables>;
export const GetSchoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geoDataStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSchools"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"educationLevel"}},{"kind":"Field","name":{"kind":"Name","value":"greatSchoolsUrl"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSchoolsQuery, GetSchoolsQueryVariables>;
export const GetPropertyStatusForRouteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyStatusForRoute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"displaySlug"}},{"kind":"Field","name":{"kind":"Name","value":"isDisplayable"}},{"kind":"Field","name":{"kind":"Name","value":"odMarketIdentifier"}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyStatusForRouteQuery, GetPropertyStatusForRouteQueryVariables>;
export const GetAddressForIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAddressForId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"casa"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"find"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAddressForIdQuery, GetAddressForIdQueryVariables>;
export const GetShortListingPropertyInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShortListingPropertyInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"sellRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"displaySlug"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsHalf"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsFull"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listingMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"buyDirectDiscountPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtLot"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}},{"kind":"Field","name":{"kind":"Name","value":"poolFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"publicRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"hoas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"feeFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"features"}}]}},{"kind":"Field","name":{"kind":"Name","value":"garageSpaces"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resizable"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}}]}}]}}]}}]} as unknown as DocumentNode<GetShortListingPropertyInfoQuery, GetShortListingPropertyInfoQueryVariables>;
export const GetLongListingPropertyInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLongListingPropertyInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"odMarketIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"statePropertyTaxRate"}},{"kind":"Field","name":{"kind":"Name","value":"sellRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"displaySlug"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsHalf"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsFull"}},{"kind":"Field","name":{"kind":"Name","value":"builderName"}},{"kind":"Field","name":{"kind":"Name","value":"exteriorStories"}},{"kind":"Field","name":{"kind":"Name","value":"sellerDisclosuresDownloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"listingMetadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"buyDirectDiscountPercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtLot"}},{"kind":"Field","name":{"kind":"Name","value":"yearBuilt"}},{"kind":"Field","name":{"kind":"Name","value":"poolFeatures"}},{"kind":"Field","name":{"kind":"Name","value":"publicRemarks"}},{"kind":"Field","name":{"kind":"Name","value":"hoas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"feeFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"features"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inGatedCommunity"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brokerage"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"licenseNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mls"}},{"kind":"Field","name":{"kind":"Name","value":"mlsId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingOfficeName"}},{"kind":"Field","name":{"kind":"Name","value":"apn"}},{"kind":"Field","name":{"kind":"Name","value":"mls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"logoRequiredDimensions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"legalText"}},{"kind":"Field","name":{"kind":"Name","value":"detailPageLogo"}},{"kind":"Field","name":{"kind":"Name","value":"detailPageLegalText"}},{"kind":"Field","name":{"kind":"Name","value":"detailPageAgentOffice"}},{"kind":"Field","name":{"kind":"Name","value":"detailPageAgentName"}},{"kind":"Field","name":{"kind":"Name","value":"detailPageMLSNumber"}},{"kind":"Field","name":{"kind":"Name","value":"detailPageContactInfo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"mlsDisplayPermission"}},{"kind":"Field","name":{"kind":"Name","value":"mlsNumber"}},{"kind":"Field","name":{"kind":"Name","value":"entryTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"sellRequestCreatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"newConstruction"}},{"kind":"Field","name":{"kind":"Name","value":"opendoorOwned"}},{"kind":"Field","name":{"kind":"Name","value":"instantTourable"}},{"kind":"Field","name":{"kind":"Name","value":"schools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"gradesOffered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"odMarketIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mapPageSlug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarListings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"displaySlug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resizable"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sqFtLot"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resizable"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"commissionBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLongListingPropertyInfoQuery, GetLongListingPropertyInfoQueryVariables>;
export const GetPropertiesByMarketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertiesByMarket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shape"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geoSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"shape"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shape"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageInput"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertiesByMarketResult"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertiesByMarketResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PropertySearchResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displaySlug"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"originalListPrice"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtAboveGrade"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtLot"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resizable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertiesByMarketQuery, GetPropertiesByMarketQueryVariables>;
export const GetIsLikedByAddressIdForCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIsLikedByAddressIdForCurrentUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isLikedByAddressIdForCurrentUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]}}]}}]} as unknown as DocumentNode<GetIsLikedByAddressIdForCurrentUserQuery, GetIsLikedByAddressIdForCurrentUserQueryVariables>;
export const GetPropertyPhotosByAddressIDsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPropertyPhotosByAddressIDs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"photoCount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"properties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"addressIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressId"}},{"kind":"Field","name":{"kind":"Name","value":"listTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"photos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pageInput"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"photoCount"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"urls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullSize"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPropertyPhotosByAddressIDsQuery, GetPropertyPhotosByAddressIDsQueryVariables>;
export const GetVariantRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVariantRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosVariantData_GrainInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"props"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleProtobuf_StructInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"autoImpression"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"grain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"props"},"value":{"kind":"Variable","name":{"kind":"Name","value":"props"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"autoImpression"},"value":{"kind":"Variable","name":{"kind":"Name","value":"autoImpression"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetVariantRequestQuery, GetVariantRequestQueryVariables>;
export const GetSeveralVariantsRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeveralVariantsRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosVariantData_GrainInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"props"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleProtobuf_StructInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVariants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"grain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"props"},"value":{"kind":"Variable","name":{"kind":"Name","value":"props"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSeveralVariantsRequestQuery, GetSeveralVariantsRequestQueryVariables>;
export const GetSeveralFeatureFlagsRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSeveralFeatureFlagsRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosVariantData_GrainInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"props"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleProtobuf_StructInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFeatureFlags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"grain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"props"},"value":{"kind":"Variable","name":{"kind":"Name","value":"props"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSeveralFeatureFlagsRequestQuery, GetSeveralFeatureFlagsRequestQueryVariables>;
export const ListLeadsOnUniqueAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListLeadsOnUniqueAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellDirect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listLeadsOnUniqueAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customerUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leads"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isQualified"}},{"kind":"Field","name":{"kind":"Name","value":"latestOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"street"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ListLeadsOnUniqueAddressesQuery, ListLeadsOnUniqueAddressesQueryVariables>;
export const GetCurrentCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCurrentCustomer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherEmails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"otherPhoneNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isAgent"}},{"kind":"Field","name":{"kind":"Name","value":"ccpaSaleOfDataOptOut"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>;
export const GetViewingAppointmentsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetViewingAppointmentsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"daysOut"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"durationMinutes"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingAppointmentsByCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_address_id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled_for"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewingAppointmentAvailabilityForListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"daysOut"},"value":{"kind":"Variable","name":{"kind":"Name","value":"daysOut"}}},{"kind":"Argument","name":{"kind":"Name","value":"durationMinutes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"durationMinutes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available_days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"available_slots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start_time"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"is_now"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]} as unknown as DocumentNode<GetViewingAppointmentsDataQuery, GetViewingAppointmentsDataQueryVariables>;
export const GetViewingAppointmentsByCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetViewingAppointmentsByCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"web"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewingAppointmentsByCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customerUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listing_address_id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled_for"}},{"kind":"Field","name":{"kind":"Name","value":"end_time"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]}}]}}]} as unknown as DocumentNode<GetViewingAppointmentsByCustomerQuery, GetViewingAppointmentsByCustomerQueryVariables>;
export const SearchZonesByLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchZonesByLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchDistance"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geoDataStore"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchZonesByLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"latitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latitude"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"longitude"},"value":{"kind":"Variable","name":{"kind":"Name","value":"longitude"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"searchDistance"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchDistance"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"NEIGHBORHOOD"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoneType"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchZonesByLocationQuery, SearchZonesByLocationQueryVariables>;
export const HistoricalMarketMetricsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoricalMarketMetricsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OdProtosSellerDashboardMetricsData_HistoricalMarketMetricsFiltersInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numWeeks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellerDashboardMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getHistoricalMarketMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"zip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zip"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"numWeeks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numWeeks"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medianSalePrice"}},{"kind":"Field","name":{"kind":"Name","value":"medianSalePriceMom"}},{"kind":"Field","name":{"kind":"Name","value":"daysOnMarket"}},{"kind":"Field","name":{"kind":"Name","value":"daysOnMarketMom"}},{"kind":"Field","name":{"kind":"Name","value":"homesSold"}},{"kind":"Field","name":{"kind":"Name","value":"homesSoldMom"}},{"kind":"Field","name":{"kind":"Name","value":"homesOnMarket"}},{"kind":"Field","name":{"kind":"Name","value":"homesOnMarketMom"}},{"kind":"Field","name":{"kind":"Name","value":"avgListingPrice"}},{"kind":"Field","name":{"kind":"Name","value":"avgListingPriceMom"}},{"kind":"Field","name":{"kind":"Name","value":"unfilteredGraphs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medianSalePriceGraph"}},{"kind":"Field","name":{"kind":"Name","value":"daysOnMarketGraph"}},{"kind":"Field","name":{"kind":"Name","value":"homesSoldGraph"}}]}},{"kind":"Field","name":{"kind":"Name","value":"filteredGraphs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medianSalePriceGraph"}},{"kind":"Field","name":{"kind":"Name","value":"daysOnMarketGraph"}},{"kind":"Field","name":{"kind":"Name","value":"homesSoldGraph"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HistoricalMarketMetricsQueryQuery, HistoricalMarketMetricsQueryQueryVariables>;
export const GetMarketMetricsQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMarketMetricsQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketIdentifier"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellerDashboardMetrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMarketMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"marketIdentifier"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketIdentifier"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"timePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"homesSold"}},{"kind":"Field","name":{"kind":"Name","value":"homesSoldWow"}},{"kind":"Field","name":{"kind":"Name","value":"newListings"}},{"kind":"Field","name":{"kind":"Name","value":"newListingsWow"}},{"kind":"Field","name":{"kind":"Name","value":"delistings"}},{"kind":"Field","name":{"kind":"Name","value":"delistingsWow"}},{"kind":"Field","name":{"kind":"Name","value":"homesOnMarket"}},{"kind":"Field","name":{"kind":"Name","value":"homesOnMarketWow"}},{"kind":"Field","name":{"kind":"Name","value":"averagePriceChange"}},{"kind":"Field","name":{"kind":"Name","value":"averagePriceChangeWow"}},{"kind":"Field","name":{"kind":"Name","value":"marketHotness"}}]}}]}}]}}]} as unknown as DocumentNode<GetMarketMetricsQueryQuery, GetMarketMetricsQueryQueryVariables>;
export const PurchaseTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PurchaseTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedOfferPrice"}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"photoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"primaryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"isPartnerAgent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"buyerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"buyerName"}},{"kind":"Field","name":{"kind":"Name","value":"buyerPhone"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionPeriodDaysRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"listingOfferId"}},{"kind":"Field","name":{"kind":"Name","value":"propertyV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"isDone"},"name":{"kind":"Name","value":"isComplete"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"taskType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionState"}},{"kind":"Field","name":{"kind":"Name","value":"resaleCloseOfEscrowDaysRemaining"}}]}}]}}]}}]} as unknown as DocumentNode<PurchaseTransactionQuery, PurchaseTransactionQueryVariables>;
export const NavTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellerInput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InContractTransaction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellDirectOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isClosed"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavTransactionsQuery, NavTransactionsQueryVariables>;
export const HubDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HubData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buying"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"favorites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketplacePropertyListResult"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledFor"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"listingAddressToken"}},{"kind":"Field","name":{"kind":"Name","value":"listingReadableAddress"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MarketplacePropertyListResult"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tourFeedbacks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tourFeedbackUuid"}},{"kind":"Field","name":{"kind":"Name","value":"viewingAppointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"selling"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sellerInput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"homeDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"physicalDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsFull"}},{"kind":"Field","name":{"kind":"Name","value":"bathroomsHalf"}},{"kind":"Field","name":{"kind":"Name","value":"sqFt"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QualifiedTransaction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AgentAttributionDecisionStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralInvitationPaymentEligibility"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReferralInvitationDecisionStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralInvitationPaymentEligibility"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssessmentStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inPersonAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isScheduled"}},{"kind":"Field","name":{"kind":"Name","value":"hasAvailableSlots"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expertHandoffAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isScheduled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"selfServeVirtualAssessment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ssvaCompletedAt"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaRecordingsSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaQuestionnaireSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaInteriorRecordingsSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaBackyardRecordingsSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaFrontyardRecordingsSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaWholeHomeRecordingsSubmitted"}},{"kind":"Field","name":{"kind":"Name","value":"ssvaSellerDisclosureDocumentRecordingsSubmitted"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ContractSigningStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSetup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseAgreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InContractTransaction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sellDirectOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isClosed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SellerStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepricingStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSetup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseAgreement"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClosingStep"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inspection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProviders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disclosures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"finalWalkthrough"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lateCheckoutAddendum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"changeCloseOfEscrowAddendum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}},{"kind":"Field","name":{"kind":"Name","value":"formAddendums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"complete"}}]}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MarketplacePropertyListResult"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplacePropertyListResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"badges"}},{"kind":"Field","name":{"kind":"Name","value":"beds"}},{"kind":"Field","name":{"kind":"Name","value":"baths"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"fullAddress"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}},{"kind":"Field","name":{"kind":"Name","value":"listDate"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"livingSquareFootage"}},{"kind":"Field","name":{"kind":"Name","value":"listingState"}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]} as unknown as DocumentNode<HubDataQuery, HubDataQueryVariables>;
export const GetBuyDirectPropertyInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyDirectPropertyInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplace"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"property"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"buyDirectPrice"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"fhaEligible"}},{"kind":"Field","name":{"kind":"Name","value":"fhaEligibleDate"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"listingState"}},{"kind":"Field","name":{"kind":"Name","value":"listingTags"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}},{"kind":"Field","name":{"kind":"Name","value":"sellerDisclosuresDownloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}}]}}]} as unknown as DocumentNode<GetBuyDirectPropertyInfoQuery, GetBuyDirectPropertyInfoQueryVariables>;
export const GetResaleOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResaleOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webListingOffer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listOffers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"identifier"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"details"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignatureId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetResaleOffersQuery, GetResaleOffersQueryVariables>;
export const GetBuyDirectS3UrlsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyDirectS3Urls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucketName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3DocumentUploadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bucketName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucketName"}}},{"kind":"Argument","name":{"kind":"Name","value":"documentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentName"}}}]},{"kind":"Field","name":{"kind":"Name","value":"s3DocumentDownloadUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bucketName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucketName"}}},{"kind":"Argument","name":{"kind":"Name","value":"s3Directory"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentName"}}}]}]}}]}}]} as unknown as DocumentNode<GetBuyDirectS3UrlsQuery, GetBuyDirectS3UrlsQueryVariables>;
export const NaturalLanguagePropertySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NaturalLanguagePropertySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"market"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"naturalLanguagePropertySearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"market"},"value":{"kind":"Variable","name":{"kind":"Name","value":"market"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"emptyReason"}},{"kind":"Field","name":{"kind":"Name","value":"properties"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchedPhotoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"property"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressToken"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"listPrice"}},{"kind":"Field","name":{"kind":"Name","value":"bedrooms"}},{"kind":"Field","name":{"kind":"Name","value":"bathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"sqFtTotalLiving"}},{"kind":"Field","name":{"kind":"Name","value":"dwellingType"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NaturalLanguagePropertySearchQuery, NaturalLanguagePropertySearchQueryVariables>;